// @ts-ignore
var _version = '1.4.2';
import { _msg, message } from './message';
import Queue from './queue';
import { code as _code } from './status';
import { utils as _utils } from './utils';
var _message = _msg;
var _msgHash: {
  [key: string]: any;
} = {};
var CryptoJS = require('crypto-js');
var clone = require('lodash.clone');

require('../dist/strophe-1.2.13.js');

// @ts-ignore
let Strophe = window.Strophe;
const EMPTYFN: () => void = () => {};
var location = window.location || { protocol: 'https:' };
// @ts-ignore
window.URL = window.URL || window.webkitURL || window.mozURL || window.msURL;

// @ts-ignore
if (window.XDomainRequest) {
  // @ts-ignore
  XDomainRequest.prototype.oldsend = XDomainRequest.prototype.send;
  // @ts-ignore
  XDomainRequest.prototype.send = function () {
    // @ts-ignore
    XDomainRequest.prototype.oldsend.apply(this, arguments);
    this.readyState = 2;
  };
}

Strophe.Request.prototype._newXHR = function () {
  var xhr = _utils.xmlrequest(true);
  if (xhr.overrideMimeType) {
    xhr.overrideMimeType('text/xml');
  }
  // use Function.bind() to prepend ourselves as an argument
  xhr.onreadystatechange = this.func.bind(null, this);
  return xhr;
};

Strophe.Websocket.prototype._closeSocket = function () {
  if (this.socket) {
    var me = this;
    setTimeout(function () {
      try {
        me.socket.close();
      } catch (e) {}
    }, 0);
  } else {
    this.socket = null;
  }
};

/**
 *
 * Strophe.Websocket has a bug while logout:
 * 1.send: <presence xmlns='jabber:client' type='unavailable'/> is ok;
 * 2.send: <close xmlns='urn:ietf:params:xml:ns:xmpp-framing'/> will cause a problem,log as follows:
 * WebSocket connection to 'ws://im-api.hyphenate.io/ws/' failed: Data frame received after close_connect @ strophe.js:5292connect @ strophe.js:2491_login @ websdk-1.1.2.js:278suc @ websdk-1.1.2.js:636xhr.onreadystatechange @ websdk-1.1.2.js:2582
 * 3 "Websocket error [object Event]"
 * _changeConnectStatus
 * onError Object {type: 7, msg: "The WebSocket connection could not be established or was disconnected.", reconnect: true}
 *
 * this will trigger socket.onError, therefore _doDisconnect again.
 * Fix it by overide  _onMessage
 */
Strophe.Websocket.prototype._onMessage = function (message: any) {
  logMessage(message);
  var elem, data;
  // check for closing stream
  // var close = '<close xmlns="urn:ietf:params:xml:ns:xmpp-framing" />';
  // if (message.data === close) {
  //     this._conn.rawInput(close);
  //     this._conn.xmlInput(message);
  //     if (!this._conn.disconnecting) {
  //         this._conn._doDisconnect();
  //     }
  //     return;
  //
  // send and receive close xml: <close xmlns='urn:ietf:params:xml:ns:xmpp-framing'/>
  // so we can't judge whether message.data equals close by === simply.
  if (message.data.indexOf('<close ') === 0) {
    elem = new DOMParser().parseFromString(message.data, 'text/xml').documentElement;
    var see_uri = elem.getAttribute('see-other-uri');
    if (see_uri) {
      this._conn._changeConnectStatus(Strophe.Status.REDIRECT, 'Received see-other-uri, resetting connection');
      this._conn.reset();
      this._conn.service = see_uri;
      this._connect();
    } else {
      // if (!this._conn.disconnecting) {
      this._conn._doDisconnect('receive <close> from server');
      // }
    }
    return;
  } else if (message.data.search('<open ') === 0) {
    // This handles stream restarts
    elem = new DOMParser().parseFromString(message.data, 'text/xml').documentElement;
    if (!this._handleStreamStart(elem)) {
      return;
    }
  } else {
    data = this._streamWrap(message.data);
    elem = new DOMParser().parseFromString(data, 'text/xml').documentElement;
  }

  if (this._check_streamerror(elem, Strophe.Status.ERROR)) {
    return;
  }

  //handle unavailable presence stanza before disconnecting
  // @ts-ignore
  if (this._conn.disconnecting && elem.firstChild?.nodeName === 'presence' && elem.firstChild?.getAttribute?.('type') === 'unavailable') {
    this._conn.xmlInput(elem);
    this._conn.rawInput(Strophe.serialize(elem));
    // if we are already disconnecting we will ignore the unavailable stanza and
    // wait for the </stream:stream> tag before we close the connection
    return;
  }
  this._conn._dataRecv(elem, message.data);
};

var _listenNetwork = function (onlineCallback: any, offlineCallback: any) {
  if (window.addEventListener) {
    window.addEventListener('online', onlineCallback);
    window.addEventListener('offline', offlineCallback);
  } else {
    // @ts-ignore
    if (typeof window.attachEvent === 'function') {
      if (document.body) {
        // @ts-ignore
        document.body.attachEvent('ononline', onlineCallback);
        // @ts-ignore
        document.body.attachEvent('onoffline', offlineCallback);
      } else {
        // @ts-ignore
        window.attachEvent('load', function () {
          // @ts-ignore
          document.body.attachEvent('ononline', onlineCallback);
          // @ts-ignore
          document.body.attachEvent('onoffline', offlineCallback);
        });
      }
    } else {
      /*var onlineTmp = window.ononline;
         var offlineTmp = window.onoffline;

         window.attachEvent('ononline', function () {
         try {
         typeof onlineTmp === 'function' && onlineTmp();
         } catch ( e ) {}
         onlineCallback();
         });
         window.attachEvent('onoffline', function () {
         try {
         typeof offlineTmp === 'function' && offlineTmp();
         } catch ( e ) {}
         offlineCallback();
         });*/
    }
  }
};

let _parseRoom = function (result: Element) {
  let rooms = [];
  let items = result.getElementsByTagName('item');
  if (items) {
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const roomJid = item.getAttribute('jid');
      const tmp = roomJid?.split('@')[0];
      let room = {
        jid: roomJid,
        name: item.getAttribute('name'),
        roomId: tmp?.split('_')[1],
      };
      rooms.push(room);
    }
  }
  return rooms;
};

var _parseRoomOccupants = function (result: any) {
  var occupants = [];
  var items = result.getElementsByTagName('item');
  if (items) {
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var room = {
        jid: item.getAttribute('jid'),
        name: item.getAttribute('name'),
      };
      occupants.push(room);
    }
  }
  return occupants;
};

const _parseFastenEditMessage = function (msgInfo: any) {
  let messageEditBody: { id?: string; data?: string } = {};
  const fastening = msgInfo.getElementsByTagName('apply-to');
  if (fastening && fastening.length > 0) {
    const edit = fastening[0].getElementsByTagName('edit');
    if (edit) {
      const customTag = msgInfo.getElementsByTagName('custom');
      if (customTag && customTag.length > 0) {
        const childNode = customTag[0].childNodes[0];
        if (childNode.nodeType == Strophe.ElementType.TEXT) {
          const jsondata = childNode.wholeText || childNode.nodeValue;
          messageEditBody.data = jsondata.replace('\n', '<br>');
        }
        messageEditBody.id = fastening[0].getAttribute('id');
      }
    }
  }
  return messageEditBody;
};

const _parseQuoteMessage = function (msginfo: any) {
  let quoteMessageData = {};
  const fastening = msginfo.getElementsByTagName('apply-to');
  if (fastening && fastening.length > 0) {
    const quotes = fastening[0].getElementsByTagName('quote');
    if (quotes && quotes.length > 0 && quotes[0].namespaceURI === 'rhp:urn:xmpp:quote') {
      const customTag = msginfo.getElementsByTagName('custom');
      if (customTag && customTag.length > 0) {
        // has quote
        const refMsgType = customTag[0].getAttribute('type');
        const refMsgTitle = customTag[0].getAttribute('refMsgTitle');

        const childNode = customTag[0].childNodes[0];
        let refMsgShortDesc;

        if (childNode.nodeType == Strophe.ElementType.TEXT) {
          var jsondata = childNode.wholeText || childNode.nodeValue;
          refMsgShortDesc = jsondata.replace('\n', '<br>');
        }

        const refMsgId = fastening[0].getAttribute('id');
        const refDisplayName = fastening[0].getAttribute('username');
        const refUserId = parseInt(fastening[0].getAttribute('userId'));
        const refMsgExpTs = customTag[0].getAttribute('refMsgExpTs');
        quoteMessageData = {
          refMsgId,
          refUserId,
          refMsgType,
          refMsgShortDesc,
          refDisplayName,
          refMsgExpTs,
          refMsgTitle,
        };
      }
    }
  }
  return quoteMessageData;
};

var _parseResponseMessage = function (msginfo: any) {
  var parseMsgData = { errorMsg: true, data: [] as any[], delayTimeStamp: undefined };
  // TODO: should refactor below code to read "to" field from message tag, not body tag
  var msgBodies = msginfo.getElementsByTagName('body');
  if (msgBodies) {
    for (var i = 0; i < msgBodies.length; i++) {
      var msgBody = msgBodies[i];
      var childNodes = msgBody.childNodes;
      if (childNodes && childNodes.length > 0) {
        var childNode = msgBody.childNodes[0];
        if (childNode.nodeType == Strophe.ElementType.TEXT) {
          var jsondata = childNode.wholeText || childNode.nodeValue;
          jsondata = jsondata.replace('\n', '<br>');
          try {
            var data = eval('(' + jsondata + ')');
            parseMsgData.errorMsg = false;
            parseMsgData.data = [data];
          } catch (e) {}
        }
      }
    }

    var delayTags = msginfo.getElementsByTagName('delay');
    if (delayTags && delayTags.length > 0) {
      var delayTag = delayTags[0];
      var delayMsgTime = delayTag.getAttribute('stamp');
      if (delayMsgTime) {
        parseMsgData.delayTimeStamp = delayMsgTime;
      }
    }
  } else {
    var childrens = msginfo.childNodes;
    if (childrens && childrens.length > 0) {
      var child = msginfo.childNodes[0];
      if (child.nodeType == Strophe.ElementType.TEXT) {
        try {
          var data = eval('(' + child.nodeValue + ')');
          parseMsgData.errorMsg = false;
          parseMsgData.data = [data];
        } catch (e) {}
      }
    }
  }
  return parseMsgData;
};

var _parseNameFromJidFn = function (jid: string, domain?: string) {
  domain = domain || '';
  var tempstr = jid;
  var findex = tempstr.indexOf('_');

  if (findex !== -1) {
    tempstr = tempstr.substring(findex + 1);
  }
  var atindex = tempstr.indexOf('@' + domain);
  if (atindex !== -1) {
    tempstr = tempstr.substring(0, atindex);
  }
  return tempstr;
};

var _parseFriend = function (queryTag: Element, conn?: typeof WebIM, from?: string) {
  var roster = [];
  var items = queryTag.getElementsByTagName('item');
  if (items) {
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var jid = item.getAttribute('jid');
      if (!jid) {
        continue;
      }
      var subscription = item.getAttribute('subscription');
      var friend: {
        subscription: string | null;
        jid: string;
        ask?: string;
        name?: string;
        groups?: any[];
      } = {
        subscription: subscription,
        jid: jid,
      };
      var ask = item.getAttribute('ask');
      if (ask) {
        friend.ask = ask;
      }
      var name = item.getAttribute('name');
      if (name) {
        friend.name = name;
      } else {
        var n = _parseNameFromJidFn(jid);
        friend.name = n;
      }
      var groups: any[] = [];
      Strophe.forEachChild(item, 'group', function (group: any) {
        groups.push(Strophe.getText(group));
      });
      friend.groups = groups;
      roster.push(friend);
      // after B agreed -> B subscribes A
      // fix: 含有ask标示的好友代表已经发送过反向订阅消息，不需要再次发送。
      if (conn && subscription == 'from' && !ask) {
        conn.subscribe({
          toJid: jid,
        });
      }

      if (conn && subscription == 'to') {
        conn.subscribed({
          toJid: jid,
        });
      }
    }
  }
  return roster;
};

var _login = function (options: any, conn: typeof WebIM) {
  var accessToken = options?.access_token || '';
  var loginJid = conn.context.jid;
  if (accessToken == '') {
    var loginfo = _utils.stringify(options);
    conn.onError({
      type: _code.WEBIM_CONNCTION_OPEN_USERGRID_ERROR,
      data: options,
    });
    return;
  }
  conn.context.accessToken = options.access_token;
  conn.context.accessTokenExpires = options.expires_in;
  var stropheConn = null;
  if (conn.isOpening() && conn.context.stropheConn) {
    stropheConn = conn.context.stropheConn;
  } else if (conn.isOpened() && conn.context.stropheConn) {
    // return;
    stropheConn = conn.getStrophe();
  } else {
    stropheConn = conn.getStrophe();
  }
  var callback = function (status: typeof Strophe.status, msg: any) {
    _loginCallback(status, msg, conn);
  };

  if (conn.isMultiLoginSessions) {
    if (options.resource) {
      loginJid += '/webim' + options.resource;
    } else {
      loginJid += '/' + options.user + 'webim' + _utils.generateJidResource();
    }
  }
  //console.log('jid=', conn.context.jid)
  conn.context.stropheConn = stropheConn;
  if (conn.route) {
    stropheConn.connect(loginJid, accessToken.startsWith('$t$') ? accessToken : '$t$' + accessToken, callback, conn.wait, conn.hold, conn.route);
  } else {
    stropheConn.connect(loginJid, accessToken.startsWith('$t$') ? accessToken : '$t$' + accessToken, callback, conn.wait, conn.hold);
  }
};

var _parseMessageType = function (msginfo: Element) {
  var receiveinfo = msginfo.getElementsByTagName('received'),
    inviteinfo = msginfo.getElementsByTagName('invite'),
    deliveryinfo = msginfo.getElementsByTagName('delivery'),
    acked = msginfo.getElementsByTagName('acked'),
    error = msginfo.getElementsByTagName('error'),
    msgtype = 'normal',
    composing = msginfo.getElementsByTagName('composing'),
    paused = msginfo.getElementsByTagName('paused'),
    deleted = msginfo.getElementsByTagName('deleted'),
    boost = msginfo.getElementsByTagName('boost'),
    updated = msginfo.getElementsByTagName('updated'),
    video = msginfo.getElementsByTagName('video'),
    liveStream = msginfo.getElementsByTagName('liveStream'),
    banned = msginfo.getElementsByTagName('banned'),
    blocked = msginfo.getElementsByTagName('blocked'),
    whisper = msginfo.getElementsByTagName('whisper'),
    fastening = msginfo.getElementsByTagName('apply-to'),
    heartMsg = msginfo.getElementsByTagName('heartMsg');

  if (receiveinfo && receiveinfo.length > 0 && receiveinfo[0].namespaceURI === 'urn:xmpp:receipts') {
    msgtype = 'received';
  } else if (inviteinfo && inviteinfo.length > 0) {
    msgtype = 'invite';
  } else if (deliveryinfo && deliveryinfo.length > 0) {
    msgtype = 'delivery'; // message delivered
  } else if (acked && acked.length) {
    msgtype = 'acked'; // message read
  } else if (composing && composing.length) {
    msgtype = 'composing'; // typing indicator: composing
  } else if (paused && paused.length) {
    msgtype = 'paused'; // typing indicator: paused
  } else if (deleted && deleted.length) {
    msgtype = 'deleted'; // message deleted
  } else if (boost && boost.length) {
    msgtype = 'boost'; // message boost
  } else if (updated && updated.length) {
    msgtype = 'updated'; // message updated
  } else if (video && video.length) {
    msgtype = 'video'; // message video call request
  } else if (liveStream && liveStream.length) {
    msgtype = 'liveStream'; // message liveStream call request
  } else if (banned && banned.length) {
    msgtype = 'banned'; // message banned request
  } else if (blocked && blocked.length) {
    msgtype = 'blocked'; // message blocked request
  } else if (whisper && whisper.length) {
    msgtype = 'whisper'; // message whisper request
  } else if (heartMsg && heartMsg.length) {
    msgtype = 'heartMsg'; // message heartMsg call request
  } else if (error && error.length) {
    var errorItem = error[0],
      userMuted = errorItem.getElementsByTagName('user-muted');

    if (userMuted && userMuted.length) {
      msgtype = 'userMuted';
    }
  } else if (fastening && fastening.length && fastening[0].namespaceURI === 'urn:xmpp:fasten:0') {
    // console.log("fastening", fastening);
    msgtype = 'fastening'; // XEP-0422: Message Fastening
  }
  return msgtype;
};

var _handleMessageQueue = function (conn: typeof WebIM) {
  for (var i in _msgHash) {
    if (_msgHash.hasOwnProperty(i)) {
      _msgHash[i].send(conn);
    }
  }
};

var _loginCallback = function (status: typeof Strophe.Status, msg: any, conn: typeof WebIM) {
  var conflict, error: any;

  if (msg === 'conflict') {
    conflict = true;
  }

  if (status == Strophe.Status.CONNFAIL) {
    //client offline, ping/pong timeout, server quit, server offline
    error = {
      type: _code.WEBIM_CONNCTION_SERVER_CLOSE_ERROR,
      msg: msg,
      reconnect: true,
      conflict: false,
    };

    conflict && (error.conflict = true);
    conn.onError(error);
  } else if (status === Strophe.Status.ATTACHED || status === Strophe.Status.CONNECTED) {
    // client should limit the speed of sending ack messages  up to 5/s
    conn.autoReconnectNumTotal = 0;
    // conn.intervalId = setInterval(function () {
    //   conn.handelSendQueue();
    // }, 200);

    var handleMessage = function (msginfo: Element) {
      ++conn.stanzasServerSendCount;
      var type = _parseMessageType(msginfo);
      if (!type) return;
      switch (type) {
        case 'fastening':
          conn.handleFasteningMessage(msginfo);
          return true;
        case 'received':
          conn.handleReceivedMessage(msginfo);
          return true;
        case 'invite':
          conn.handleInviteMessage(msginfo);
          return true;
        case 'delivery':
          conn.handleDeliveredMessage(msginfo);
          return true;
        case 'acked':
          conn.handleAckedMessage(msginfo);
          return true;
        case 'userMuted':
          conn.handleMutedMessage(msginfo);
          return true;
        case 'composing':
        case 'paused':
          conn.handleChatStateChanged(msginfo, type);
          return true;
        case 'deleted':
          conn.handleDeletedMessage(msginfo);
          return true;
        case 'boost':
          conn.handleMessageBoost(msginfo);
          return true;
        case 'updated':
          conn.handleUpdatedMessage(msginfo);
          return true;
        // case "video": // Do not handle video here, we handle in conn.handleMessage
        //   console.log("msginfo", msginfo)
        //   conn.handleVideoMessage(msginfo, type);
        //   return true;
        default:
          conn.handleMessage(msginfo);
          return true;
      }
    };
    var handlePresence = function (msginfo: Element) {
      ++conn.stanzasServerSendCount;
      conn.handlePresence(msginfo);
      return true;
    };
    var handlePing = function (msginfo: Element) {
      ++conn.stanzasServerSendCount;
      conn.handlePing(msginfo);
      return true;
    };
    var handleIqRoster = function (msginfo: Element) {
      ++conn.stanzasServerSendCount;
      conn.handleIqRoster(msginfo);
      return true;
    };
    var handleIqPrivacy = function (msginfo: Element) {
      ++conn.stanzasServerSendCount;
      conn.handleIqPrivacy(msginfo);
      return true;
    };
    var handleIq = function (msginfo: Element) {
      ++conn.stanzasServerSendCount;
      conn.handleIq(msginfo);
      return true;
    };
    var handleStreamResponseFromServer = function (msginfo: Element) {
      conn.handleStreamResponseFromServer(msginfo);
      return true;
    };
    var handleStreamManagementEnabledSuccess = function (msginfo: Element) {
      conn.handleStreamManagementEnabledSuccess(msginfo);
      return true;
    };

    var handleStreamRequestFromServer = function (msginfo: Element) {
      conn.handleStreamRequestFromServer(msginfo);
      return true;
    };

    var handleDiscoveryFeature = function (msginfo: Element) {
      conn.handleDiscoveryFeature(msginfo);
      return true;
    };

    conn.addHandler(handleMessage, null, 'message', null, null, null);
    conn.addHandler(handlePresence, null, 'presence', null, null, null);
    conn.addHandler(handlePing, 'urn:xmpp:ping', 'iq', 'get', null, null);
    conn.addHandler(handleIqRoster, 'jabber:iq:roster', 'iq', 'set', null, null);
    conn.addHandler(handleIqPrivacy, 'jabber:iq:privacy', 'iq', 'set', null, null);
    conn.addHandler(handleIq, null, 'iq', null, null, null);
    conn.addHandler(handleStreamResponseFromServer, null, 'a', null, null, null);
    conn.addHandler(handleStreamManagementEnabledSuccess, 'urn:xmpp:sm:3', 'enabled', null, null, null);
    conn.addHandler(handleStreamRequestFromServer, 'urn:xmpp:sm:3', 'r', null, null, null);
    conn.addHandler(handleDiscoveryFeature, null, 'iq', 'result', null, null);

    conn.registerConfrIQHandler && conn.registerConfrIQHandler();

    conn.context.status = _code.STATUS_OPENED;

    var supportRecMessage = [_code.WEBIM_MESSAGE_REC_TEXT];

    if (_utils.isCanDownLoadFile) {
      supportRecMessage.push(_code.WEBIM_MESSAGE_REC_PHOTO);
      supportRecMessage.push(_code.WEBIM_MESSAGE_REC_AUDIO_FILE);
    }
    var supportSedMessage = [_code.WEBIM_MESSAGE_SED_TEXT];
    if (_utils.isCanUploadFile) {
      supportSedMessage.push(_code.WEBIM_MESSAGE_REC_PHOTO);
      supportSedMessage.push(_code.WEBIM_MESSAGE_REC_AUDIO_FILE);
    }
    //conn.notifyVersion();
    conn.retry && _handleMessageQueue(conn);
    conn.heartBeat(conn.isHeartBeatEnable);
    conn.isAutoLogin && conn.setPresence();
    conn.onOpened({
      canReceive: supportRecMessage,
      canSend: supportSedMessage,
      accessToken: conn.context.accessToken,
    });
  } else if (status == Strophe.Status.DISCONNECTING) {
    //console.log("DISCONNECTING");
    if (conn.isOpened()) {
      conn.stopHeartBeat();
      conn.context.status = _code.STATUS_CLOSING;

      error = {
        type: _code.WEBIM_CONNCTION_SERVER_CLOSE_ERROR,
        msg: msg,
        reconnect: true,
      };

      conflict && (error.conflict = true);
      conn.onError(error);
    }
  } else if (status == Strophe.Status.DISCONNECTED) {
    conn.handelUnAcknowledgeQueueAfterDisconnect();
    //console.log("DISCONNECTED")
    if (conn.isOpened()) {
      if (conn.autoReconnectNumTotal < conn.autoReconnectNumMax) {
        console.log('reconnect');
        conn.reconnect();
        return;
      } else {
        error = {
          type: _code.WEBIM_CONNCTION_DISCONNECTED,
        };
        conn.onError(error);
      }
    }
    conn.context.status = _code.STATUS_CLOSED;
    conn.clear();
    conflict && (error.conflict = true);
    conn.onClosed(error);
  } else if (status == Strophe.Status.AUTHFAIL) {
    //console.log("AUTHFAIL")
    error = {
      type: _code.WEBIM_CONNCTION_AUTH_ERROR,
    };

    conflict && (error.conflict = true);
    conn.onError(error);
    conn.handelUnAcknowledgeQueueAfterDisconnect();
    conn.clear();
  } else if (status == Strophe.Status.ERROR) {
    //console.log("ERROR")
    conn.context.status = _code.STATUS_ERROR;
    error = {
      type: _code.WEBIM_CONNCTION_SERVER_ERROR,
    };

    conflict && (error.conflict = true);
    conn.onError(error);
  } else {
    conn.onError(error);
  }
  conn.context.status_now = status;
};

var _getJid = function (options: any, conn: typeof WebIM) {
  var jid = options.toJid || '';

  if (jid === '') {
    var appKey = conn.context.appKey || '';
    var toJid = appKey + '_' + options.to + '@' + conn.domain;

    if (options.resource) {
      toJid = toJid + '/' + options.resource;
    }
    jid = toJid;
  }
  return jid;
};

var _getJidByName = function (name: string, conn: typeof WebIM) {
  var options = {
    to: name,
  };
  return _getJid(options, conn);
};

var _validCheck = function (options: any, conn: typeof WebIM) {
  options = options || {};

  if (options.user == '') {
    conn.onError({
      type: _code.WEBIM_CONNCTION_USER_NOT_ASSIGN_ERROR,
    });
    return false;
  }

  var user = options.user + '' || '';
  var appKey = options.appKey || '';
  var devInfos = appKey.split('#');

  if (devInfos.length !== 2) {
    conn.onError({
      type: _code.WEBIM_CONNCTION_APPKEY_NOT_ASSIGN_ERROR,
    });
    return false;
  }
  var orgName = devInfos[0];
  var appName = devInfos[1];

  if (!orgName) {
    conn.onError({
      type: _code.WEBIM_CONNCTION_APPKEY_NOT_ASSIGN_ERROR,
    });
    return false;
  }
  if (!appName) {
    conn.onError({
      type: _code.WEBIM_CONNCTION_APPKEY_NOT_ASSIGN_ERROR,
    });
    return false;
  }

  var jid = appKey + '_' + user.toLowerCase() + '@' + conn.domain,
    resource = options.resource || 'webim';

  /*if (conn.isMultiLoginSessions) {
    resource += user + new Date().getTime() + Math.floor(Math.random().toFixed(6) * 1000000);
  }*/

  conn.context.jid = jid; // + '/' + resource;
  /*jid: {appkey}_{username}@domain/resource*/
  conn.context.userId = user;
  conn.context.appKey = appKey;
  conn.context.appName = appName;
  conn.context.orgName = orgName;

  return true;
};

var _getXmppUrl = function (baseUrl: string, https: boolean) {
  if (/^(ws|http)s?:\/\/?/.test(baseUrl)) {
    return baseUrl;
  }

  var url = {
    prefix: 'http',
    base: '://' + baseUrl,
    suffix: '/http-bind/',
  };

  if (https && _utils.isSupportWss) {
    url.prefix = 'wss';
    url.suffix = '/ws/';
  } else {
    if (https) {
      url.prefix = 'https';
    } else if (window.WebSocket) {
      url.prefix = 'ws';
      url.suffix = '/ws/';
    }
  }

  return url.prefix + url.base + url.suffix;
};

// class
var connection = function (this: any, _options: any): any {
  // @ts-ignore
  if ((!this) instanceof connection) {
    // @ts-ignore
    return new connection(_options);
  }

  var options = _options || {};

  this.isHttpDNS = options.isHttpDNS || false;
  this.isMultiLoginSessions = options.isMultiLoginSessions || false;
  this.wait = options.wait || 30;
  this.retry = options.retry || false;
  this.https = options.https || location.protocol === 'https:';
  this.url = _getXmppUrl(options.url, this.https);
  this.hold = options.hold || 1;
  this.route = options.route || null;
  this.domain = options.domain;
  this.inactivity = options.inactivity || 30;
  this.heartBeatWait = options.heartBeatWait || 4500;
  this.pingTimeout = options.pingTimeout || 10000; //10 seconds
  this.isHeartBeatEnable = options.isHeartBeatEnable || false;
  this.maxRetries = options.maxRetries || 5;
  this.isAutoLogin = options.isAutoLogin === false ? false : true;
  this.pollingTime = options.pollingTime || 800;
  this.stropheConn = false;
  this.autoReconnectNumMax = options.autoReconnectNumMax || 0;
  this.autoReconnectNumTotal = 0;
  this.autoReconnectInterval = options.autoReconnectInterval || 0;
  this.context = { status: _code.STATUS_INIT };
  this.sendQueue = new Queue(); //instead of sending message immediately,cache them in this queue
  this.unAcknowledgeQueue = new Queue(); //instead of sending request immediately,cache them in this queue
  this.intervalId = null; //clearInterval return value
  this.apiUrl = options.apiUrl || '';
  this.isWindowSDK = options.isWindowSDK || false;
  this.encrypt = options.encrypt || { encrypt: { type: 'none' } };
  this.delivery = options.delivery || false;
  this.user = '';
  this.orgName = '';
  this.appName = '';
  this.token = '';

  this.dnsArr = ['https://rs.easemob.com', 'https://rsbak.easemob.com', 'http://182.92.174.78', 'http://112.126.66.111']; //http dns server hosts
  this.dnsIndex = 0; //the dns ip used in dnsArr currently
  this.dnsTotal = this.dnsArr.length; //max number of getting dns retries
  this.restHosts = null; //rest server ips
  this.restIndex = 0; //the rest ip used in restHosts currently
  this.restTotal = 0; //max number of getting rest token retries
  this.xmppHosts = null; //xmpp server ips
  this.xmppIndex = 0; //the xmpp ip used in xmppHosts currently
  this.xmppTotal = 0; //max number of creating xmpp server connection(ws/bosh) retries

  this.groupOption = {};
  this.streamManagementEnabled = false;
  this.stanzasClientSendCount = 0;
  this.stanzasServerSendCount = 0;
  this.chatStateCount = 0;
  this.requestDeliveredCount = 0;
  this.stanzasClientLastAckIndex = 0;
  this.numberOfUnackMsgToCheckForReceipt = options.numberOfUnackMsgToCheckForReceipt || 5;

  // Managing Discussion History xep-0045
  this.limitSecondTimeGetGroupChatMessage = options.limitSecondTimeGetGroupChatMessage || 0;

  //Flag on - off feature
  this.enableAdvancedMessageProcessing = false; // XEP-0079: Advanced Message Processing
};

connection.prototype.registerUser = function (options: any) {
  if (location.protocol != 'https:' && this.isHttpDNS) {
    this.dnsIndex = 0;
    this.getHttpDNS(options, 'signup');
  } else {
    this.signup(options);
  }
};

connection.prototype.handelSendQueue = function () {
  var options = this.sendQueue.pop();
  if (options !== null) {
    this.sendReceiptsMessage(options);
  }
};

connection.prototype.handelCheckFailedDeliveryMessage = function (h: number) {
  let unackMessages = [];
  let ackMessages = [];
  const arrayUnAcknowledge = [...this.unAcknowledgeQueue.getArray()];
  for (let i = 0; i < arrayUnAcknowledge.length; i++) {
    const item = arrayUnAcknowledge[i];
    if (item.x <= h) {
      ackMessages.push(item);
    } else {
      unackMessages.push(item);
    }
  }
  // set unAcknowledgeQueue to only keep unackMessages, remove all the failed messages being handled in this function
  this.unAcknowledgeQueue.setArray(unackMessages);
  let failedMessageQueue = unackMessages.filter(item => item.index <= this.stanzasClientLastAckIndex);
  if (failedMessageQueue.length !== 0) {
    this._onMessageSendFailed(failedMessageQueue);
  }
  this.onSendMessageSuccess(ackMessages);
};

connection.prototype.listen = function (options: any) {
  this.onOpened = options.onOpened || _utils.emptyfn;
  this.onClosed = options.onClosed || _utils.emptyfn;
  this.onTextMessage = options.onTextMessage || _utils.emptyfn;
  this.onFastenEditTxtMessage = options.onFastenEditTxtMessage || _utils.emptyfn;
  this.onGifMessage = options.onGifMessage || _utils.emptyfn;
  this.onGiftMessage = options.onGiftMessage || _utils.emptyfn;
  this.onShareLocationMessage = options.onShareLocationMessage || _utils.emptyfn;
  this.onShareDateMessage = options.onShareDateMessage || _utils.emptyfn;
  this.onShareEventMessage = options.onShareEventMessage || _utils.emptyfn;
  this.onShareEventTicketMessage = options.onShareEventTicketMessage || _utils.emptyfn;
  this.onScreenshotMessage = options.onScreenshotMessage || _utils.emptyfn;
  this.onRemovedFromGroupMessage = options.onRemovedFromGroupMessage || _utils.emptyfn;
  this.onUserJoinGroupMessage = options.onUserJoinGroupMessage || _utils.emptyfn;
  this.onUserLeaveGroupMessage = options.onUserLeaveGroupMessage || _utils.emptyfn;
  this.onInviteGroupMessage = options.onInviteGroupMessage || _utils.emptyfn;
  this.onInviteGroupChatMessage = options.onInviteGroupChatMessage || _utils.emptyfn;
  this.onGalleryMessage = options.onGalleryMessage || _utils.emptyfn;
  this.onEmojiMessage = options.onEmojiMessage || _utils.emptyfn;
  this.addLogService = options.addLogService || _utils.emptyfn;
  this.onPictureMessage = options.onPictureMessage || _utils.emptyfn;
  this.onVideoFileMessage = options.onVideoFileMessage || _utils.emptyfn;
  this.onAudioMessage = options.onAudioMessage || _utils.emptyfn;
  this.onAudioFileMessage = options.onAudioFileMessage || _utils.emptyfn;
  this.onVideoMessage = options.onVideoMessage || _utils.emptyfn;
  this.onLiveStreamMessage = options.onLiveStreamMessage || _utils.emptyfn;
  this.onBannedMessage = options.onBannedMessage || _utils.emptyfn;
  this.onBlockedMessage = options.onBlockedMessage || _utils.emptyfn;
  this.onWhisperStatus = options.onWhisperStatus || _utils.emptyfn;
  this.onHeartMessage = options.onHeartMessage || _utils.emptyfn;
  this.onLinkMessage = options.onLinkMessage || _utils.emptyfn;
  this.onNotificationMessage = options.onNotificationMessage || _utils.emptyfn;
  this.onFileMessage = options.onFileMessage || _utils.emptyfn;
  this.onLocationMessage = options.onLocationMessage || _utils.emptyfn;
  this.onCmdMessage = options.onCmdMessage || _utils.emptyfn;
  this.onPresence = options.onPresence || _utils.emptyfn;
  this.onRoster = options.onRoster || _utils.emptyfn;
  this.onError = options.onError || _utils.emptyfn;
  this.onConnectionStatusChanged = options.onConnectionStatusChanged || _utils.emptyfn;
  this.onReceivedMessage = options.onReceivedMessage || _utils.emptyfn;
  this.onInviteMessage = options.onInviteMessage || _utils.emptyfn;
  this.onDeliverdMessage = options.onDeliveredMessage || _utils.emptyfn;
  this.onReadMessage = options.onReadMessage || _utils.emptyfn;
  this.onDeletedMessage = options.onDeletedMessage || _utils.emptyfn;
  this.onMessageBoost = options.onMessageBoost || _utils.emptyfn;
  this.onUpdatedMessage = options.onUpdatedMessage || _utils.emptyfn;
  this.onChatStateChanged = options.onChatStateChanged || _utils.emptyfn;
  this.onMutedMessage = options.onMutedMessage || _utils.emptyfn;
  this.onOffline = options.onOffline || _utils.emptyfn;
  this.onOnline = options.onOnline || _utils.emptyfn;
  this.onConfirmPop = options.onConfirmPop || _utils.emptyfn;
  this.onCreateGroup = options.onCreateGroup || _utils.emptyfn;
  //for WindowSDK start
  this.onUpdateMyGroupList = options.onUpdateMyGroupList || _utils.emptyfn;
  this.onUpdateMyRoster = options.onUpdateMyRoster || _utils.emptyfn;
  //for WindowSDK end
  this.onBlacklistUpdate = options.onBlacklistUpdate || _utils.emptyfn;
  this.onPingOK = options.onPingOK || _utils.emptyfn;
  this.onPingTimeout = options.onPingTimeout || _utils.emptyfn;

  this.onEnableStreamManagementSuccess = options.onEnableStreamManagementSuccess || _utils.emptyfn;
  this.onSendMessageFail = options.onSendMessageFail || _utils.emptyfn;
  this.onSendMessageSuccess = options.onSendMessageSuccess || _utils.emptyfn;
  this.onRequestDeliveredTimeout = options.onRequestDeliveredTimeout || _utils.emptyfn;

  // Fastening message
  this.onReceiveReactionMessage = options.onReceiveReactionMessage || _utils.emptyfn;
  this.onFastenDeleteMessage = options.onFastenDeleteMessage || _utils.emptyfn;
  this.onReceiveQuoteMessage = options.onReceiveQuoteMessage || _utils.emptyfn;

  _listenNetwork(this.onOnline, this.onOffline);
};

// webrtc needs to force heartbeat, add a default parameter of false for backward compatibility
connection.prototype.heartBeat = function (forcing = false) {
  var me = this;
  //IE8: strophe auto switch from ws to BOSH, need heartbeat
  // @ts-ignore
  var isNeed = !/^ws|wss/.test(me.url) || /mobile/.test(navigator.userAgent);
  if (this.heartBeatID || (!forcing && !isNeed)) {
    return;
  }

  var options = {
    toJid: this.domain,
    type: 'normal',
  };
  this.heartBeatID = setInterval(function () {
    me.ping(options);
  }, this.heartBeatWait);
};

connection.prototype.stopHeartBeat = function () {
  if (typeof this.heartBeatID == 'number') {
    this.heartBeatID = clearInterval(this.heartBeatID);
  }
};

connection.prototype.sendPingMessage = function (_options: any) {
  var options = {
    toJid: this.domain,
    type: 'normal',
    success: (_options && _options.success) || _utils.emptyfn,
    error: (_options && _options.error) || _utils.emptyfn,
    onPingTimeout: (_options && _options.onPingTimeout) || _utils.emptyfn,
  };
  var me = this;
  // this.addLogService(`sendPingMessage: ${options.onPingTimeout}`);
  me.ping(options);
};

connection.prototype._onPingTimeout = function (cb: Function) {
  this.onPingTimeout(cb);
};

connection.prototype.cleanUpStreamManagement = function () {
  this.streamManagementEnabled = false;
  this.stanzasClientSendCount = 0;
  this.stanzasServerSendCount = 0;
  this.chatStateCount = 0;
  this.requestDeliveredCount = 0;
  this.stanzasClientLastAckIndex = 0;
  this.unAcknowledgeQueue.clear();
};

connection.prototype.handelUnAcknowledgeQueueAfterDisconnect = function () {
  let unAcknowledgeMessages = this.unAcknowledgeQueue.getArray();
  if (unAcknowledgeMessages.length !== 0) {
    this._onMessageSendFailed(unAcknowledgeMessages);
  }
  this.cleanUpStreamManagement();
};

connection.prototype._onMessageSendFailed = function (messages: any[]) {
  var me = this;
  var callback = function () {
    try {
      //Handel after onSendMessageFail
      me.stanzasClientSendCount = me.stanzasClientSendCount - messages.length;
      let newQueue = me.unAcknowledgeQueue.getArray().map((item: any) => {
        item.x = item.x - messages.length;
        return item;
      });
      me.unAcknowledgeQueue.setArray(newQueue);
    } catch (error) {
      console.log('call back error', error);
    }
  };
  console.log('send ERROR to UI', messages);
  let failedDisplayableMessages = messages.filter(item => item.isDisplayableMessage);
  this.onSendMessageFail(failedDisplayableMessages, callback);
};

connection.prototype.sendReceiptsMessage = function (options: any) {
  // @ts-ignore
  var dom = $msg({
    from: this.context.jid || '',
    to: this.domain,
    id: options.id || '',
  }).c('received', {
    xmlns: 'urn:xmpp:receipts',
    id: options.id || '',
  });
  //this.sendCommand(dom.tree());
};

connection.prototype.cacheReceiptsMessage = function (options: any) {
  this.sendQueue.push(options);
};

connection.prototype.queueUnacknowledgeRequest = function (options: any) {
  this.unAcknowledgeQueue.push(options);
};

connection.prototype.getStrophe = function () {
  if (location.protocol != 'https:' && this.isHttpDNS) {
    //TODO: try this.xmppTotal times on fail
    var url = '';
    var host = this.xmppHosts[this.xmppIndex];
    var domain = _utils.getXmlFirstChild(host, 'domain');
    var ip = _utils.getXmlFirstChild(host, 'ip');
    if (ip) {
      url = ip.textContent;
      var port = _utils.getXmlFirstChild(host, 'port');
      if (port.textContent != '80') {
        url += ':' + port.textContent;
      }
    } else {
      url = domain.textContent;
    }

    if (url != '') {
      var parter = /(.+\/\/).+(\/.+)/;
      this.url = this.url.replace(parter, '$1' + url + '$2');
    }
  }
  Strophe.addConnectionPlugin('statusChange', {
    _conn: null,
    statusChanged: this.onConnectionStatusChanged,
    init: function (conn: typeof WebIM) {
      this._conn = conn;
    },
  });
  var stropheConn = new Strophe.Connection(this.url, {
    inactivity: this.inactivity,
    maxRetries: this.maxRetries,
    pollingTime: this.pollingTime,
  });
  return stropheConn;
};

connection.prototype.getHostsByTag = function (data: Element, tagName: string) {
  var tag = _utils.getXmlFirstChild(data, tagName);
  if (!tag) {
    console.log(tagName + ' hosts error');
    return null;
  }
  var hosts = tag.getElementsByTagName('hosts');
  if (hosts.length == 0) {
    console.log(tagName + ' hosts error2');
    return null;
  }
  return hosts[0].getElementsByTagName('host');
};

connection.prototype.getRestFromHttpDNS = function (options: any, type: string) {
  if (this.restIndex > this.restTotal) {
    console.log('rest hosts all tried,quit');
    return;
  }
  var url = '';
  var host = this.restHosts[this.restIndex];
  var domain = _utils.getXmlFirstChild(host, 'domain');
  var ip = _utils.getXmlFirstChild(host, 'ip');
  if (ip) {
    var port = _utils.getXmlFirstChild(host, 'port');
    url = (location.protocol === 'https:' ? 'https:' : 'http:') + '//' + ip.textContent + ':' + port.textContent;
  } else {
    url = (location.protocol === 'https:' ? 'https:' : 'http:') + '//' + domain.textContent;
  }

  if (url != '') {
    this.apiUrl = url;
    options.apiUrl = url;
  }

  if (type == 'login') {
    this.login(options);
  } else {
    this.signup(options);
  }
};

connection.prototype.getHttpDNS = function (options: any, type: string) {
  if (this.restHosts) {
    this.getRestFromHttpDNS(options, type);
    return;
  }
  var self = this;
  var suc = function (data: any, xhr: any) {
    data = new DOMParser().parseFromString(data, 'text/xml').documentElement;
    //get rest ips
    var restHosts = self.getHostsByTag(data, 'rest');
    if (!restHosts) {
      console.log('rest hosts error3');
      return;
    }
    self.restHosts = restHosts;
    self.restTotal = restHosts.length;

    //get xmpp ips
    var xmppHosts = self.getHostsByTag(data, 'xmpp');
    if (!xmppHosts) {
      console.log('xmpp hosts error3');
      return;
    }
    self.xmppHosts = xmppHosts;
    self.xmppTotal = xmppHosts.length;

    self.getRestFromHttpDNS(options, type);
  };
  var error = function (res: any, xhr: any, msg: any) {
    console.log('getHttpDNS error', res, msg);
    self.dnsIndex++;
    if (self.dnsIndex < self.dnsTotal) {
      self.getHttpDNS(options, type);
    }
  };
  var options2 = {
    url: this.dnsArr[this.dnsIndex] + '/easemob/server.xml',
    dataType: 'text',
    type: 'GET',

    // url: 'http://www.easemob.com/easemob/server.xml',
    // dataType: 'xml',
    data: { app_key: encodeURIComponent(options.appKey) },
    success: suc || _utils.emptyfn,
    error: error || _utils.emptyfn,
  };
  _utils.ajax(options2);
};

connection.prototype.signup = function (options: any) {
  var self = this;
  var orgName = options.orgName || '';
  var appName = options.appName || '';
  var appKey = options.appKey || '';
  var suc = options.success || EMPTYFN;
  var err = options.error || EMPTYFN;

  if (!orgName && !appName && appKey) {
    var devInfos = appKey.split('#');
    if (devInfos.length === 2) {
      orgName = devInfos[0];
      appName = devInfos[1];
    }
  }
  if (!orgName && !appName) {
    err({
      type: _code.WEBIM_CONNCTION_APPKEY_NOT_ASSIGN_ERROR,
    });
    return;
  }

  var error = function (res: any, xhr: any, msg: any) {
    if (location.protocol != 'https:' && self.isHttpDNS) {
      if (self.restIndex + 1 < self.restTotal) {
        self.restIndex++;
        self.getRestFromHttpDNS(options, 'signup');
        return;
      }
    }
    self.clear();
    err(res);
  };
  // var https = options.https || https;
  var apiUrl = options.apiUrl;
  var restUrl = apiUrl + '/' + orgName + '/' + appName + '/users';

  var userjson = {
    username: options.username,
    password: options.password,
    nickname: options.nickname || '',
  };

  var userinfo = _utils.stringify(userjson);
  var options2 = {
    url: restUrl,
    dataType: 'json',
    data: userinfo,
    success: suc,
    error: error,
  };
  _utils.ajax(options2);
};

connection.prototype.open = function (options: any) {
  var appkey = options.appKey,
    orgName = appkey.split('#')[0],
    appName = appkey.split('#')[1];
  this.orgName = orgName;
  this.appName = appName;
  if (options.accessToken) {
    this.token = options.accessToken;
  }
  if (options.xmppURL) {
    this.url = _getXmppUrl(options.xmppURL, this.https);
  }
  if (location.protocol != 'https:' && this.isHttpDNS) {
    this.dnsIndex = 0;
    this.getHttpDNS(options, 'login');
  } else {
    this.login(options);
  }
};

connection.prototype.login = function (options: any) {
  this.user = options.user;
  var pass = _validCheck(options, this);

  if (!pass) {
    return;
  }

  var conn = this;

  if (conn.isOpened()) {
    return;
  }

  if (options.accessToken) {
    options.access_token = options.accessToken;
    conn.context.restTokenData = options;
    _login(options, conn);
  } else {
    var apiUrl = options.apiUrl;
    var userId = this.context.userId;
    var pwd = options.pwd || '';
    var appName = this.context.appName;
    var orgName = this.context.orgName;

    var suc = function (data: any, xhr: any) {
      conn.context.status = _code.STATUS_DOLOGIN_IM;
      conn.context.restTokenData = data;
      if (options.success) options.success(data);
      conn.token = data.access_token;
      _login(data, conn);
    };
    var error = function (res: any, xhr: any, msg: any) {
      if (options.error) options.error();
      if (location.protocol != 'https:' && conn.isHttpDNS) {
        if (conn.restIndex + 1 < conn.restTotal) {
          conn.restIndex++;
          conn.getRestFromHttpDNS(options, 'login');
          return;
        }
      }
      conn.clear();
      if (res.error && res.error_description) {
        conn.onError({
          type: _code.WEBIM_CONNCTION_OPEN_USERGRID_ERROR,
          data: res,
          xhr: xhr,
        });
      } else {
        conn.onError({
          type: _code.WEBIM_CONNCTION_OPEN_ERROR,
          data: res,
          xhr: xhr,
        });
      }
    };

    this.context.status = _code.STATUS_DOLOGIN_USERGRID;

    var loginJson = {
      grant_type: 'password',
      username: userId,
      password: pwd,
      timestamp: +new Date(),
    };
    var loginfo = _utils.stringify(loginJson);

    var options2 = {
      url: apiUrl + '/' + orgName + '/' + appName + '/token',
      dataType: 'json',
      data: loginfo,
      success: suc || _utils.emptyfn,
      error: error || _utils.emptyfn,
    };
    _utils.ajax(options2);
  }
};

// attach to xmpp server for BOSH
connection.prototype.attach = function (options: any) {
  var pass = _validCheck(options, this);

  if (!pass) {
    return;
  }

  options = options || {};

  var accessToken = options.accessToken || '';
  if (accessToken == '') {
    this.onError({
      type: _code.WEBIM_CONNCTION_TOKEN_NOT_ASSIGN_ERROR,
    });
    return;
  }

  var sid = options.sid || '';
  if (sid === '') {
    this.onError({
      type: _code.WEBIM_CONNCTION_SESSIONID_NOT_ASSIGN_ERROR,
    });
    return;
  }

  var rid = options.rid || '';
  if (rid === '') {
    this.onError({
      type: _code.WEBIM_CONNCTION_RID_NOT_ASSIGN_ERROR,
    });
    return;
  }

  var stropheConn = this.getStrophe();

  this.context.accessToken = accessToken;
  this.context.stropheConn = stropheConn;
  this.context.status = _code.STATUS_DOLOGIN_IM;

  var conn = this;
  var callback = function (status: typeof Strophe.Status, msg: any) {
    _loginCallback(status, msg, conn);
  };

  var jid = this.context.jid;
  var wait = this.wait;
  var hold = this.hold;
  var wind = this.wind || 5;
  if (conn.isMultiLoginSessions) {
    if (options.resource) {
      jid += '/webim' + options.resource;
    } else {
      jid += '/' + options.user + 'webim' + _utils.generateJidResource();
    }
  }

  stropheConn.attach(jid, sid, rid, callback, wait, hold, wind);
};

connection.prototype.close = function (reason: string) {
  this.stopHeartBeat();

  var status = this.context.status;
  if (status == _code.STATUS_INIT) {
    return;
  }

  if (this.isClosed() || this.isClosing()) {
    return;
  }

  this.context.status = _code.STATUS_CLOSING;
  if (this.context && this.context.stropheConn && typeof this.context.stropheConn.disconnect === 'function') this.context.stropheConn.disconnect(reason);
};

connection.prototype.addHandler = function (handler: any, ns: any, name: string, type: string, id: string, from: string, options: any) {
  this.context.stropheConn.addHandler(handler, ns, name, type, id, from, options);
};

connection.prototype.notifyVersion = function (_suc: any, fail: any) {
  var jid = _getJid({}, this);
  // @ts-ignore
  var dom = $iq({
    from: this.context.jid || '',
    to: this.domain,
    type: 'result',
  })
    .c('query', { xmlns: 'jabber:iq:version' })
    .c('name')
    .t('hyphenate')
    .up()
    .c('version')
    .t(_version)
    .up()
    .c('os')
    .t('webim');

  var suc = _suc || EMPTYFN;
  var error = fail || this.onError;
  var failFn = function (ele: any) {
    error({
      type: _code.WEBIM_CONNCTION_NOTIFYVERSION_ERROR,
      data: ele,
    });
  };
  this.sendCommand(dom.tree(), suc, failFn);
};

// handle all types of presence message
connection.prototype.handlePresence = function (msginfo: Element) {
  if (this.isClosed()) {
    return;
  }

  var from = msginfo.getAttribute('from') || '';
  var to = msginfo.getAttribute('to') || '';
  var type = msginfo.getAttribute('type') || '';
  var presence_type = msginfo.getAttribute('presence_type') || '';
  var fromUser = _parseNameFromJidFn(from);
  var toUser = _parseNameFromJidFn(to);
  var isCreate = false;
  var isMemberJoin = false;
  var isDecline = false;
  var isApply = false;
  const info: {
    from: string;
    to: string;
    fromJid: string;
    toJid: string;
    type: string;
    owner?: string;
    chatroom: boolean;
    presence_type?: string;
    original_type?: string;
    show?: string;
    status?: string;
    code?: string | null;
    priority?: string;
    error?: any;
    reason?: string;
    destroy?: boolean;
    toNick?: string;
    gid?: string | null;
    isMemberJoin?: boolean;
    isPublicLiveStream?: boolean;
    isOwnerPublicLiveStream?: boolean;
    mid?: string;
  } = {
    from: fromUser,
    to: toUser,
    fromJid: from,
    toJid: to,
    type: type,
    chatroom: msginfo.getElementsByTagName('roomtype').length ? true : false,
  };

  var showTags = msginfo.getElementsByTagName('show');
  if (showTags && showTags.length > 0) {
    var showTag = showTags[0];
    info.show = Strophe.getText(showTag);
  }
  var statusTags = msginfo.getElementsByTagName('status');
  if (statusTags && statusTags.length > 0) {
    var statusTag = statusTags[0];
    info.status = Strophe.getText(statusTag);
    info.code = statusTag.getAttribute('code');
  }
  if (showTags && showTags.length > 0 && statusTags && statusTags.length > 0) {
    info.type = 'updateStatus';
  }

  var priorityTags = msginfo.getElementsByTagName('priority');
  if (priorityTags && priorityTags.length > 0) {
    var priorityTag = priorityTags[0];
    info.priority = Strophe.getText(priorityTag);
  }

  const error = msginfo.getElementsByTagName('error');
  if (error && error.length > 0) {
    const e = error[0];
    info.error = {
      code: e.getAttribute('code'),
    };
  }

  const members = msginfo.getElementsByTagName('item');
  if (members && members.length > 0) {
    const member = members[0];
    const role = member.getAttribute('role');
    const jid = member.getAttribute('jid');
    const affiliation = member.getAttribute('affiliation');
    // dismissed by group
    if (role == 'none' && jid) {
      // var kickedMember = _parseNameFromJidFn(jid);
      // var actor = member.getElementsByTagName('actor')[0];
      // var actorNick = actor.getAttribute('nick');
      // info.actor = actorNick;
      // info.kicked = kickedMember;
    }
    // Service Acknowledges Room Creation `createGroupACK`
    if (role == 'moderator' && info.code == '201') {
      if (affiliation === 'owner') {
        info.type = 'createGroupACK';
        isCreate = true;
      }
      // else
      //     info.type = 'joinPublicGroupSuccess';
    }
  }

  const x = msginfo.getElementsByTagName('x');
  if (x && x.length > 0) {
    // 加群申请
    const apply = x[0].getElementsByTagName('apply');
    // 加群成功
    const accept = x[0].getElementsByTagName('accept');
    // 同意加群后用户进群通知
    const item = x[0].getElementsByTagName('item');
    // 加群被拒绝
    const decline = x[0].getElementsByTagName('decline');
    // 被设为管理员
    const addAdmin = x[0].getElementsByTagName('add_admin');
    // 被取消管理员
    const removeAdmin = x[0].getElementsByTagName('remove_admin');
    // 被禁言
    const addMute = x[0].getElementsByTagName('add_mute');
    // 取消禁言
    const removeMute = x[0].getElementsByTagName('remove_mute');

    const destroy = x[0].getElementsByTagName('destroy');
    if (destroy && destroy.length > 0) {
      info.destroy = true;
      var reason = destroy[0].getElementsByTagName('reason');
      if (reason && reason.length > 0) {
        info.reason = Strophe.getText(reason[0]);
      }
      info.type = 'destroy';
    } else if (apply && apply.length > 0) {
      isApply = true;
      info.toNick = apply[0].getAttribute('toNick') || undefined;
      info.type = 'joinGroupNotifications';
      const groupJid = apply[0].getAttribute('to');
      const gid = groupJid?.split('@')[0].split('_') || '';
      info.gid = gid[gid.length - 1];
    } else if (accept && accept.length > 0) {
      info.type = 'joinPublicGroupSuccess';
    } else if (item && item.length > 0) {
      var isPublicLiveStream = item[0].getAttribute('isPublicLiveStream');
      var isOwnerPublicLiveStream = item[0].getAttribute('isOwnerPublicLiveStream');
      var affiliation = item[0].getAttribute('affiliation'),
        role = item[0].getAttribute('role');
      nick = item[0].getAttribute('nick');
      if (type === 'unavailable' && role === 'none') {
        isMemberJoin = false;
        info.isMemberJoin = false;
        info.type = 'memberLeaveGroupSuccess';
      } else if ((affiliation == 'member' || role == 'moderator' || role == 'participant') && (!showTags || showTags.length === 0)) {
        isMemberJoin = true;
        info.isMemberJoin = isMemberJoin;
        const mid = info.fromJid.split('/');
        info.mid = mid[mid.length - 1];
        info.isPublicLiveStream = !!isPublicLiveStream;
        info.isOwnerPublicLiveStream = !!isOwnerPublicLiveStream;
        info.type = 'memberJoinPublicGroupSuccess';
      }
    } else if (decline && decline.length) {
      isDecline = true;
      const gid = decline[0].getAttribute('fromNick');
      info.owner = _parseNameFromJidFn(decline[0].getAttribute('from') || '');
      info.type = 'joinPublicGroupDeclined';
      info.gid = gid;
    } else if (addAdmin && addAdmin.length > 0) {
      const gid = _parseNameFromJidFn(addAdmin[0].getAttribute('mucjid') || '');
      info.owner = _parseNameFromJidFn(addAdmin[0].getAttribute('from') || '');
      info.gid = gid;
      info.type = 'addAdmin';
    } else if (removeAdmin && removeAdmin.length > 0) {
      info.gid = _parseNameFromJidFn(removeAdmin[0].getAttribute('mucjid') || '');
      info.owner = _parseNameFromJidFn(removeAdmin[0].getAttribute('from') || '');
      info.type = 'removeAdmin';
    } else if (addMute && addMute.length > 0) {
      info.gid = _parseNameFromJidFn(addMute[0].getAttribute('mucjid') || '');
      info.owner = _parseNameFromJidFn(addMute[0].getAttribute('from') || '');
      info.type = 'addMute';
    } else if (removeMute && removeMute.length > 0) {
      info.gid = _parseNameFromJidFn(removeMute[0].getAttribute('mucjid') || '');
      info.owner = _parseNameFromJidFn(removeMute[0].getAttribute('from') || '');
      info.type = 'removeMute';
    }
  }

  if (info.chatroom) {
    // diff the
    info.presence_type = presence_type;
    info.original_type = info.type;
    const reflectUser = from.slice(from.lastIndexOf('/') + 1);

    if (reflectUser === this.context.userId) {
      if (info.type === '' && !info.code) {
        info.type = 'joinChatRoomSuccess';
      } else if (presence_type === 'unavailable' || info.type === 'unavailable') {
        if (!info.status) {
          // logout successfully.
          info.type = 'leaveChatRoom';
        } else {
          // @ts-ignore
          if (info.code == 110) {
            // logout or dismissied by admin.
            info.type = 'leaveChatRoom';
          } else if (info.error && info.error.code == 406) {
            // The chat room is full.
            info.type = 'reachChatRoomCapacity';
          }
        }
      }
    }
  } else {
    info.presence_type = presence_type;
    info.original_type = type;

    if (/subscribe/.test(info.type)) {
      //subscribe | subscribed | unsubscribe | unsubscribed
    } else if (type == '' && !info.status && !info.error && !isCreate && !isApply && !isMemberJoin && !isDecline) {
      // info.type = 'joinPublicGroupSuccess';
    } else if (presence_type === 'unavailable' || type === 'unavailable') {
      // There is no roomtype when a chat room is deleted.
      if (info.destroy) {
        // Group or Chat room Deleted.
        info.type = 'deleteGroupChat';
      } else {
        // @ts-ignore
        if (info.code == 307 || info.code == 321) {
          // Dismissed by group.
          var nick = msginfo.getAttribute('nick');
          if (!nick) info.type = 'leaveGroup';
          else info.type = 'removedFromGroup';
        }
      }
    }
  }
  this.onPresence(info, msginfo);
};

connection.prototype.handlePing = function (e: Element) {
  if (this.isClosed()) {
    return;
  }
  var id = e.getAttribute('id');
  var from = e.getAttribute('from');
  var to = e.getAttribute('to');
  // @ts-ignore
  var dom = $iq({
    from: to,
    to: from,
    id: id,
    type: 'result',
  });
  this.sendCommand(dom.tree());
};

connection.prototype.handleIq = function (iq: Element) {
  const type = iq.getAttribute('type') || '';
  const nameSpace = iq.getAttribute('xmlns') || '';
  const from = iq.getAttribute('from') || '';

  if (type === 'result' && nameSpace === 'jabber:client' && from === this.domain) {
    // this.addLogService(`clearTimeout in handleIq pingOK pingTimeoutID: ${this.pingTimeoutID}`);
    clearTimeout(this.pingTimeoutID);
    this.pingTimeoutID = null;
    this.onPingOK();
  }
  return true;
};

connection.prototype.handleStreamResponseFromServer = function (a: Element) {
  --this.requestDeliveredCount;
  const stanzasServerReceiveCount = a.getAttribute('h') || '';
  if (this.requestDeliveredTimeout) {
    clearTimeout(this.requestDeliveredTimeout);
    this.requestDeliveredTimeout = null;
  }
  if (this.requestDeliveredCount === 0) this.handelCheckFailedDeliveryMessage(stanzasServerReceiveCount);
  return true;
};

connection.prototype.handleStreamManagementEnabledSuccess = function () {
  // console.log('handleStreamManagementEnabledSuccess')
  this.streamManagementEnabled = true;
  this.onEnableStreamManagementSuccess();
  return true;
};

connection.prototype.handleStreamRequestFromServer = function () {
  // @ts-ignore
  const dom = $build('a', {
    xmlns: 'urn:xmpp:sm:3',
    h: this.stanzasServerSendCount,
  });
  this.context.stropheConn.send(dom.tree());
  return true;
};

connection.prototype.handleDiscoveryFeature = function (msginfo: Element) {
  var items = msginfo.getElementsByTagName('feature');

  if (items) {
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var protocol = item.getAttribute('var');
      if (!protocol) {
        continue;
      }
      switch (protocol) {
        // Add more flag later
        case 'http://jabber.org/protocol/amp':
          this.enableAdvancedMessageProcessing = true;
          break;
        default:
          break;
      }
    }
  }
  return true;
};

connection.prototype.handleIqPrivacy = function (msginfo: Element) {
  var list = msginfo.getElementsByTagName('list');
  if (list.length == 0) {
    return;
  }
  this.getBlacklist();
};

connection.prototype.handleIqRoster = function (e: Element) {
  var id = e.getAttribute('id');
  var from = e.getAttribute('from') || '';
  var name = _parseNameFromJidFn(from);
  var curJid = this.context.jid;
  var curUser = this.context.userId;

  // @ts-ignore
  var iqresult = $iq({ type: 'result', id: id, from: curJid });
  this.sendCommand(iqresult.tree());

  var msgBodies = e.getElementsByTagName('query');
  if (msgBodies && msgBodies.length > 0) {
    var queryTag = msgBodies[0];
    var rouster = _parseFriend(queryTag, this, from);
    this.onRoster(rouster);
  }
  return true;
};

connection.prototype.handleMessage = function (msginfo: Element) {
  var self = this;
  if (this.isClosed()) {
    return;
  }
  var id = msginfo.getAttribute('id') || '';

  // cache ack into sendQueue first , handelSendQueue will do the send thing with the speed of  5/s
  // this.cacheReceiptsMessage({
  //   id: id
  // });

  var parseMsgData = _parseResponseMessage(msginfo);
  if (parseMsgData.errorMsg) {
    this.handlePresence(msginfo);
    return;
  }
  // send error
  const error = msginfo.getElementsByTagName('error');
  let errorCode: string | null = '';
  let errorText = '';
  let errorBool = false;
  if (error.length > 0) {
    errorBool = true;
    errorCode = error[0].getAttribute('code');
    const textDOM = error[0].getElementsByTagName('text');
    // @ts-ignore
    errorText = textDOM[0].textContent || textDOM[0].text;
  }
  var msgDatas = parseMsgData.data;
  for (var i in msgDatas) {
    if (!msgDatas.hasOwnProperty(i)) {
      continue;
    }
    var msg = msgDatas[i];
    if (!msg.from || !msg.to) {
      continue;
    }
    var from = (msg.from + '').toLowerCase();
    var too = (msg.to + '').toLowerCase();
    var extmsg = msg.ext || {};
    var chattype = '';
    var typeEl = msginfo.getElementsByTagName('roomtype');

    var forwardedMessage = msginfo.getElementsByTagName('forwarded');
    var isForwardedMessage = forwardedMessage.length > 0;

    if (typeEl.length) {
      chattype = typeEl[0].getAttribute('type') || 'chat';
    } else if (msg.type === 'private-msg') {
      chattype = msg.type;
    } else {
      chattype = msginfo.getAttribute('type') || 'chat';
    }
    var msgBodies = msg.bodies;
    if (!msgBodies || msgBodies.length == 0) {
      continue;
    }
    var msgBody = msg.bodies[0];
    var type = msgBody.type;

    // Fastening message
    const quoteMessageData = _parseQuoteMessage(msginfo);
    const customTag = msginfo.getElementsByTagName('custom');
    const expts = customTag?.[0]?.getAttribute('expts') ? parseInt(<string>customTag?.[0]?.getAttribute('expts')) : 0;
    // console.log("msg", msg);
    // console.log("msgBody", msgBody);
    // console.log("type", type);
    // console.log("quoteMessageData", quoteMessageData);
    try {
      let receiveMsg = msgBody.data;
      switch (type) {
        case 'fastenTxtEdit':
          this.onFastenEditTxtMessage({ ..._parseFastenEditMessage(msginfo), from: from, to: too, type: 'fastenTxtEdit' });
          break;
        case 'txt':
          if (self.encrypt.type === 'base64') {
            receiveMsg = _utils.atob(receiveMsg);
          } else if (self.encrypt.type === 'aes') {
            const key = CryptoJS.enc.Utf8.parse(self.encrypt.key);
            const iv = CryptoJS.enc.Utf8.parse(self.encrypt.iv);
            const mode = self.encrypt.mode.toLowerCase();
            let option = {};
            if (mode === 'cbc') {
              option = {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
              };
            } else if (mode === 'ebc') {
              option = {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
              };
            }
            const encryptedBase64Str = receiveMsg;
            const decryptedData = CryptoJS.AES.decrypt(encryptedBase64Str, key, option);
            receiveMsg = decryptedData.toString(CryptoJS.enc.Utf8);
          }
          const emojibody = _utils.parseTextMessage(receiveMsg, WebIM.Emoji);
          if (emojibody && emojibody.isemoji) {
            const msgTxt = {
              id: id,
              type: chattype,
              from: from,
              to: too,
              delay: parseMsgData.delayTimeStamp,
              data: emojibody.body,
              ext: extmsg,
              isForwardedMessage: isForwardedMessage,
              time: msgBody.time,
              ...quoteMessageData,
              error: errorBool,
              errorText: errorText,
              errorCode: errorCode,
            };
            !msgTxt.delay && delete msgTxt.delay;
            this.onEmojiMessage(msgTxt);
          } else {
            const msgTxt: any = {
              id: id,
              type: chattype,
              from: from,
              to: too,
              delay: parseMsgData.delayTimeStamp,
              data: receiveMsg,
              ext: extmsg,
              isModerator: msgBody.isModerator,
              expts: msgBody.expts || 0,
              isForwardedMessage: isForwardedMessage,
              time: msgBody.time,
              ...quoteMessageData,
              error: errorBool,
              errorText: errorText,
              errorCode: errorCode,
              senderMemberLevel: msgBody.senderMemberLevel,
              recvMemberLevel: msgBody.recvMemberLevel,
              isRecvMatching: msgBody.isRecvMatching,
              isSenderMatching: msgBody.isSenderMatching,
              notificationType: msgBody.notificationType,
              profilePhotoComment: msgBody.profilePhotoComment,
            };
            !msgTxt.delay && delete msgTxt.delay;
            this.onTextMessage(msgTxt);
          }
          break;
        case 'gift':
          if (self.encrypt.type === 'base64') {
            receiveMsg = _utils.atob(receiveMsg);
          } else if (self.encrypt.type === 'aes') {
            const key = CryptoJS.enc.Utf8.parse(self.encrypt.key);
            const iv = CryptoJS.enc.Utf8.parse(self.encrypt.iv);
            const mode = self.encrypt.mode.toLowerCase();
            let option = {};
            if (mode === 'cbc') {
              option = {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
              };
            } else if (mode === 'ebc') {
              option = {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
              };
            }
            const encryptedBase64Str = receiveMsg;
            const decryptedData = CryptoJS.AES.decrypt(encryptedBase64Str, key, option);
            receiveMsg = decryptedData.toString(CryptoJS.enc.Utf8);
          }

          const msgGift = {
            id: id,
            type: chattype,
            from: from,
            to: too,
            delay: parseMsgData.delayTimeStamp,
            data: receiveMsg,
            ext: extmsg,
            expts: msgBody.expts || 0,
            isForwardedMessage: isForwardedMessage,
            time: msgBody.time,
            ...quoteMessageData,
            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
            senderMemberLevel: msgBody.senderMemberLevel,
            recvMemberLevel: msgBody.recvMemberLevel,
            isRecvMatching: msgBody.isRecvMatching,
            isSenderMatching: msgBody.isSenderMatching,
            isModerator: msgBody.isModerator,
          };
          !msgGift.delay && delete msgGift.delay;
          this.onGiftMessage(msgGift);
          break;
        case 'shareLocation':
          if (self.encrypt.type === 'base64') {
            receiveMsg = _utils.atob(receiveMsg);
          } else if (self.encrypt.type === 'aes') {
            const key = CryptoJS.enc.Utf8.parse(self.encrypt.key);
            const iv = CryptoJS.enc.Utf8.parse(self.encrypt.iv);
            const mode = self.encrypt.mode.toLowerCase();
            let option = {};
            if (mode === 'cbc') {
              option = {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
              };
            } else if (mode === 'ebc') {
              option = {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
              };
            }
            const decryptedData = CryptoJS.AES.decrypt(receiveMsg, key, option);
            receiveMsg = decryptedData.toString(CryptoJS.enc.Utf8);
          }
          const msgShareLocation = {
            id,
            type: chattype,
            from: from,
            to: too,
            delay: parseMsgData.delayTimeStamp,
            data: receiveMsg,
            ext: extmsg,
            expts: msgBody.expts || 0,
            isForwardedMessage: isForwardedMessage,
            time: msgBody.time,
            ...quoteMessageData,
            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
            senderMemberLevel: msgBody.senderMemberLevel,
            recvMemberLevel: msgBody.recvMemberLevel,
            isRecvMatching: msgBody.isRecvMatching,
            isSenderMatching: msgBody.isSenderMatching,
            isModerator: msgBody.isModerator,
            profilePhotoComment: msgBody.profilePhotoComment,
          };
          !msgShareLocation.delay && delete msgShareLocation.delay;
          this.onShareLocationMessage(msgShareLocation);
          break;
        case 'shareDate':
          if (self.encrypt.type === 'base64') {
            receiveMsg = _utils.atob(receiveMsg);
          } else if (self.encrypt.type === 'aes') {
            const key = CryptoJS.enc.Utf8.parse(self.encrypt.key);
            const iv = CryptoJS.enc.Utf8.parse(self.encrypt.iv);
            const mode = self.encrypt.mode.toLowerCase();
            let option = {};
            if (mode === 'cbc') {
              option = {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
              };
            } else if (mode === 'ebc') {
              option = {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
              };
            }
            const decryptedData = CryptoJS.AES.decrypt(receiveMsg, key, option);
            receiveMsg = decryptedData.toString(CryptoJS.enc.Utf8);
          }

          const msgShareDate = {
            id: id,
            type: chattype,
            from: from,
            to: too,
            delay: parseMsgData.delayTimeStamp,
            data: receiveMsg,
            ext: extmsg,
            expts: msgBody.expts || 0,
            isForwardedMessage: isForwardedMessage,
            time: msgBody.time,
            ...quoteMessageData,

            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
            senderMemberLevel: msgBody.senderMemberLevel,
            recvMemberLevel: msgBody.recvMemberLevel,
            isRecvMatching: msgBody.isRecvMatching,
            isSenderMatching: msgBody.isSenderMatching,
            isModerator: msgBody.isModerator,
            profilePhotoComment: msgBody.profilePhotoComment,
          };
          !msgShareDate.delay && delete msgShareDate.delay;
          this.onShareDateMessage(msgShareDate);
          break;
        case 'shareEvent':
          if (self.encrypt.type === 'base64') {
            receiveMsg = _utils.atob(receiveMsg);
          } else if (self.encrypt.type === 'aes') {
            const key = CryptoJS.enc.Utf8.parse(self.encrypt.key);
            const iv = CryptoJS.enc.Utf8.parse(self.encrypt.iv);
            const mode = self.encrypt.mode.toLowerCase();
            let option = {};
            if (mode === 'cbc') {
              option = {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
              };
            } else if (mode === 'ebc') {
              option = {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
              };
            }
            const decryptedData = CryptoJS.AES.decrypt(receiveMsg, key, option);
            receiveMsg = decryptedData.toString(CryptoJS.enc.Utf8);
          }

          const msgShareEvent = {
            id: id,
            type: chattype,
            from: from,
            to: too,
            delay: parseMsgData.delayTimeStamp,
            data: receiveMsg,
            ext: extmsg,
            expts: msgBody.expts || 0,
            isForwardedMessage: isForwardedMessage,
            time: msgBody.time,
            ...quoteMessageData,

            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
            senderMemberLevel: msgBody.senderMemberLevel,
            recvMemberLevel: msgBody.recvMemberLevel,
            isRecvMatching: msgBody.isRecvMatching,
            isSenderMatching: msgBody.isSenderMatching,
            isModerator: msgBody.isModerator,
            profilePhotoComment: msgBody.profilePhotoComment,
          };
          !msgShareEvent.delay && delete msgShareEvent.delay;
          this.onShareEventMessage(msgShareEvent);
          break;

        case 'shareEventTicket':
          if (self.encrypt.type === 'base64') {
            receiveMsg = _utils.atob(receiveMsg);
          } else if (self.encrypt.type === 'aes') {
            const key = CryptoJS.enc.Utf8.parse(self.encrypt.key);
            const iv = CryptoJS.enc.Utf8.parse(self.encrypt.iv);
            const mode = self.encrypt.mode.toLowerCase();
            let option = {};
            if (mode === 'cbc') {
              option = {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
              };
            } else if (mode === 'ebc') {
              option = {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
              };
            }
            const decryptedData = CryptoJS.AES.decrypt(receiveMsg, key, option);
            receiveMsg = decryptedData.toString(CryptoJS.enc.Utf8);
          }

          var shareEventTicket = {
            id: id,
            type: chattype,
            from: from,
            to: too,
            delay: parseMsgData.delayTimeStamp,
            data: receiveMsg,
            ext: extmsg,
            expts: msgBody.expts || 0,
            isForwardedMessage: isForwardedMessage,
            time: msgBody.time,
            ...quoteMessageData,

            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
            senderMemberLevel: msgBody.senderMemberLevel,
            recvMemberLevel: msgBody.recvMemberLevel,
            isRecvMatching: msgBody.isRecvMatching,
            isSenderMatching: msgBody.isSenderMatching,
            isModerator: msgBody.isModerator,
            profilePhotoComment: msgBody.profilePhotoComment,
          };
          !shareEventTicket.delay && delete shareEventTicket.delay;
          this.onShareEventTicketMessage(shareEventTicket);
          break;
        case 'screenshot':
          if (self.encrypt.type === 'base64') {
            receiveMsg = _utils.atob(receiveMsg);
          } else if (self.encrypt.type === 'aes') {
            const key = CryptoJS.enc.Utf8.parse(self.encrypt.key);
            const iv = CryptoJS.enc.Utf8.parse(self.encrypt.iv);
            const mode = self.encrypt.mode.toLowerCase();
            let option = {};
            if (mode === 'cbc') {
              option = {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
              };
            } else if (mode === 'ebc') {
              option = {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
              };
            }
            const decryptedData = CryptoJS.AES.decrypt(receiveMsg, key, option);

            decryptedData.toString(CryptoJS.enc.Utf8);
          }

          const msgScreenshot = {
            id: id,
            type: chattype,
            from: from,
            to: too,
            delay: parseMsgData.delayTimeStamp,
            data: receiveMsg,
            ext: extmsg,
            expts: msgBody.expts || 0,
            isForwardedMessage: isForwardedMessage,
            time: msgBody.time,
            ...quoteMessageData,
            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
            senderMemberLevel: msgBody.senderMemberLevel,
            recvMemberLevel: msgBody.recvMemberLevel,
            isRecvMatching: msgBody.isRecvMatching,
            isSenderMatching: msgBody.isSenderMatching,
            isModerator: msgBody.isModerator,
          };
          !msgScreenshot.delay && delete msgScreenshot.delay;
          this.onScreenshotMessage(msgScreenshot);
          break;
        case 'removedFromGroup':
          if (self.encrypt.type === 'base64') {
            receiveMsg = _utils.atob(receiveMsg);
          } else if (self.encrypt.type === 'aes') {
            const key = CryptoJS.enc.Utf8.parse(self.encrypt.key);
            const iv = CryptoJS.enc.Utf8.parse(self.encrypt.iv);
            const mode = self.encrypt.mode.toLowerCase();
            let option = {};
            if (mode === 'cbc') {
              option = {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
              };
            } else if (mode === 'ebc') {
              option = {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
              };
            }
            const decryptedData = CryptoJS.AES.decrypt(receiveMsg, key, option);
            decryptedData.toString(CryptoJS.enc.Utf8);
          }

          const removedFromGroup = {
            id: id,
            type: chattype,
            from: from,
            to: too,
            delay: parseMsgData.delayTimeStamp,
            data: receiveMsg,
            ext: extmsg,
            expts: msgBody.expts || 0,
            isForwardedMessage: isForwardedMessage,
            time: msgBody.time,
            ...quoteMessageData,
            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
          };
          !removedFromGroup.delay && delete removedFromGroup.delay;
          this.onRemovedFromGroupMessage(removedFromGroup);
          break;
        case 'joinGroupChat':
          if (self.encrypt.type === 'base64') {
            receiveMsg = _utils.atob(receiveMsg);
          } else if (self.encrypt.type === 'aes') {
            const key = CryptoJS.enc.Utf8.parse(self.encrypt.key);
            const iv = CryptoJS.enc.Utf8.parse(self.encrypt.iv);
            const mode = self.encrypt.mode.toLowerCase();
            let option = {};
            if (mode === 'cbc') {
              option = {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
              };
            } else if (mode === 'ebc') {
              option = {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
              };
            }
            const encryptedBase64Str = receiveMsg;
            const decryptedData = CryptoJS.AES.decrypt(encryptedBase64Str, key, option);

            decryptedData.toString(CryptoJS.enc.Utf8);
          }

          const msgJoinGroupChat = {
            id: id,
            type: chattype,
            from: from,
            to: too,
            delay: parseMsgData.delayTimeStamp,
            data: receiveMsg,
            ext: extmsg,
            expts: msgBody.expts || 0,
            isForwardedMessage: isForwardedMessage,
            time: msgBody.time,
            ...quoteMessageData,
            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
          };
          !msgJoinGroupChat.delay && delete msgJoinGroupChat.delay;
          this.onUserJoinGroupMessage(msgJoinGroupChat);
          break;
        case 'leaveGroupChat':
          if (self.encrypt.type === 'base64') {
            receiveMsg = _utils.atob(receiveMsg);
          } else if (self.encrypt.type === 'aes') {
            const key = CryptoJS.enc.Utf8.parse(self.encrypt.key);
            const iv = CryptoJS.enc.Utf8.parse(self.encrypt.iv);
            const mode = self.encrypt.mode.toLowerCase();
            let option = {};
            if (mode === 'cbc') {
              option = {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
              };
            } else if (mode === 'ebc') {
              option = {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
              };
            }
            const encryptedBase64Str = receiveMsg;
            const decryptedData = CryptoJS.AES.decrypt(encryptedBase64Str, key, option);

            decryptedData.toString(CryptoJS.enc.Utf8);
          }

          const msgLeaveGroupChat = {
            id: id,
            type: chattype,
            from: from,
            to: too,
            delay: parseMsgData.delayTimeStamp,
            data: receiveMsg,
            ext: extmsg,
            expts: msgBody.expts || 0,
            isForwardedMessage: isForwardedMessage,
            time: msgBody.time,
            ...quoteMessageData,
            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
          };
          !msgLeaveGroupChat.delay && delete msgLeaveGroupChat.delay;
          this.onUserLeaveGroupMessage(msgLeaveGroupChat);
          break;
        case 'inviteGroupChat':
          if (self.encrypt.type === 'base64') {
            receiveMsg = _utils.atob(receiveMsg);
          } else if (self.encrypt.type === 'aes') {
            const key = CryptoJS.enc.Utf8.parse(self.encrypt.key);
            const iv = CryptoJS.enc.Utf8.parse(self.encrypt.iv);
            const mode = self.encrypt.mode.toLowerCase();
            let option = {};
            if (mode === 'cbc') {
              option = {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
              };
            } else if (mode === 'ebc') {
              option = {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
              };
            }
            const encryptedBase64Str = receiveMsg;
            const decryptedData = CryptoJS.AES.decrypt(encryptedBase64Str, key, option);

            decryptedData.toString(CryptoJS.enc.Utf8);
          }

          const msgInviteGroupChat = {
            id: id,
            type: chattype,
            from: from,
            to: too,
            delay: parseMsgData.delayTimeStamp,
            data: receiveMsg,
            ext: extmsg,
            expts: msgBody.expts || 0,
            isForwardedMessage: isForwardedMessage,
            time: msgBody.time,
            ...quoteMessageData,

            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
            senderMemberLevel: msgBody.senderMemberLevel,
            recvMemberLevel: msgBody.recvMemberLevel,
            isRecvMatching: msgBody.isRecvMatching,
            isSenderMatching: msgBody.isSenderMatching,
            isModerator: msgBody.isModerator,
          };
          !msgInviteGroupChat.delay && delete msgInviteGroupChat.delay;
          this.onInviteGroupChatMessage(msgInviteGroupChat);
          break;

        case 'inviteGroup':
          if (self.encrypt.type === 'base64') {
            receiveMsg = _utils.atob(receiveMsg);
          } else if (self.encrypt.type === 'aes') {
            const key = CryptoJS.enc.Utf8.parse(self.encrypt.key);
            const iv = CryptoJS.enc.Utf8.parse(self.encrypt.iv);
            const mode = self.encrypt.mode.toLowerCase();
            let option = {};
            if (mode === 'cbc') {
              option = {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
              };
            } else if (mode === 'ebc') {
              option = {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
              };
            }
            const encryptedBase64Str = receiveMsg;
            const decryptedData = CryptoJS.AES.decrypt(encryptedBase64Str, key, option);

            decryptedData.toString(CryptoJS.enc.Utf8);
          }

          const msgInviteGroup = {
            id: id,
            type: chattype,
            from: from,
            to: too,
            delay: parseMsgData.delayTimeStamp,
            data: receiveMsg,
            ext: extmsg,
            expts: msgBody.expts || 0,
            isForwardedMessage: isForwardedMessage,
            time: msgBody.time,
            ...quoteMessageData,

            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
            senderMemberLevel: msgBody.senderMemberLevel,
            recvMemberLevel: msgBody.recvMemberLevel,
            isRecvMatching: msgBody.isRecvMatching,
            isSenderMatching: msgBody.isSenderMatching,
            isModerator: msgBody.isModerator,
          };
          !msgInviteGroup.delay && delete msgInviteGroup.delay;
          this.onInviteGroupMessage(msgInviteGroup);
          break;
        case 'gif':
          if (self.encrypt.type === 'base64') {
            receiveMsg = _utils.atob(receiveMsg);
          } else if (self.encrypt.type === 'aes') {
            const key = CryptoJS.enc.Utf8.parse(self.encrypt.key);
            const iv = CryptoJS.enc.Utf8.parse(self.encrypt.iv);
            const mode = self.encrypt.mode.toLowerCase();
            let option = {};
            if (mode === 'cbc') {
              option = {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
              };
            } else if (mode === 'ebc') {
              option = {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
              };
            }
            const encryptedBase64Str = receiveMsg;
            const decryptedData = CryptoJS.AES.decrypt(encryptedBase64Str, key, option);

            decryptedData.toString(CryptoJS.enc.Utf8);
          }

          const msgGif = {
            id: id,
            type: chattype,
            from: from,
            to: too,
            delay: parseMsgData.delayTimeStamp,
            data: receiveMsg,
            ext: extmsg,
            expts: msgBody.expts || 0,
            isForwardedMessage: isForwardedMessage,
            time: msgBody.time,
            ...quoteMessageData,
            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
            senderMemberLevel: msgBody.senderMemberLevel,
            recvMemberLevel: msgBody.recvMemberLevel,
            isRecvMatching: msgBody.isRecvMatching,
            isSenderMatching: msgBody.isSenderMatching,
            isModerator: msgBody.isModerator,
            profilePhotoComment: msgBody.profilePhotoComment,
          };
          !msgGif.delay && delete msgGif.delay;
          this.onGifMessage(msgGif);
          break;
        case 'gallery': //@@@@@khanhduong add new
          if (self.encrypt.type === 'base64') {
            receiveMsg = _utils.atob(receiveMsg);
          } else if (self.encrypt.type === 'aes') {
            const key = CryptoJS.enc.Utf8.parse(self.encrypt.key);
            const iv = CryptoJS.enc.Utf8.parse(self.encrypt.iv);
            const mode = self.encrypt.mode.toLowerCase();
            let option = {};
            if (mode === 'cbc') {
              option = {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
              };
            } else if (mode === 'ebc') {
              option = {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
              };
            }
            const decryptedData = CryptoJS.AES.decrypt(receiveMsg, key, option);

            decryptedData.toString(CryptoJS.enc.Utf8);
          }

          const msgGallery = {
            id: id,
            type: chattype,
            from: from,
            to: too,
            delay: parseMsgData.delayTimeStamp,
            data: receiveMsg,
            ext: extmsg,
            expts: msgBody.expts || 0,
            isForwardedMessage: isForwardedMessage,
            time: msgBody.time,
            ...quoteMessageData,

            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
            senderMemberLevel: msgBody.senderMemberLevel,
            recvMemberLevel: msgBody.recvMemberLevel,
            isRecvMatching: msgBody.isRecvMatching,
            isSenderMatching: msgBody.isSenderMatching,
            profilePhotoComment: msgBody.profilePhotoComment,
          };
          !msgGallery.delay && delete msgGallery.delay;
          this.onGalleryMessage(msgGallery);
          break;
        case 'img':
          const msgImg = {
            id: id,
            type: chattype,
            from: from,
            to: too,
            // url: (location.protocol != 'https:' && self.isHttpDNS) ? (self.apiUrl + msgBody.url.substr(msgBody.url.indexOf("/", 9))) : msgBody.url //@@@@@khanhduong update
            data: location.protocol != 'https:' && self.isHttpDNS ? self.apiUrl + msgBody.data.substr(msgBody.data.indexOf('/', 9)) : msgBody.data,
            secret: msgBody.secret,
            filename: msgBody.filename,
            thumb: msgBody.thumb,
            thumb_secret: msgBody.thumb_secret,
            file_length: msgBody.file_length || '',
            width: msgBody.size?.width || 0,
            height: msgBody.size?.height || 0,
            filetype: msgBody.filetype || '',
            accessToken: this.context.accessToken || '',
            ext: extmsg,
            delay: parseMsgData.delayTimeStamp,
            expts: msgBody.expts || expts,
            createdAt: msgBody.createdAt,
            isForwardedMessage: isForwardedMessage,
            time: msgBody.time,
            ...quoteMessageData,
            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
            senderMemberLevel: msgBody.senderMemberLevel,
            recvMemberLevel: msgBody.recvMemberLevel,
            isRecvMatching: msgBody.isRecvMatching,
            isSenderMatching: msgBody.isSenderMatching,
            profilePhotoComment: msgBody.profilePhotoComment,
          };
          !msgImg.delay && delete msgImg.delay;
          this.onPictureMessage(msgImg);
          break;
        case 'videoFile':
          const msgVideoFile = {
            id: id,
            type: chattype,
            from: from,
            to: too,
            // url: (location.protocol != 'https:' && self.isHttpDNS) ? (self.apiUrl + msgBody.url.substr(msgBody.url.indexOf("/", 9))) : msgBody.url //@@@@@khanhduong update
            data: location.protocol != 'https:' && self.isHttpDNS ? self.apiUrl + msgBody.data.substr(msgBody.data.indexOf('/', 9)) : msgBody.data,
            secret: msgBody.secret,
            filename: msgBody.filename,
            thumb: msgBody.thumb,
            thumb_secret: msgBody.thumb_secret,
            file_length: msgBody.file_length || '',
            width: msgBody.size?.width || 0,
            height: msgBody.size?.height || 0,
            filetype: msgBody.filetype || '',
            accessToken: this.context.accessToken || '',
            ext: extmsg,
            delay: parseMsgData.delayTimeStamp,
            expts: msgBody.expts || expts,
            createdAt: msgBody.createdAt,
            isForwardedMessage: isForwardedMessage,
            time: msgBody.time,
            ...quoteMessageData,
            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
            senderMemberLevel: msgBody.senderMemberLevel,
            recvMemberLevel: msgBody.recvMemberLevel,
            isRecvMatching: msgBody.isRecvMatching,
            isSenderMatching: msgBody.isSenderMatching,
            profilePhotoComment: msgBody.profilePhotoComment,
          };
          !msgVideoFile.delay && delete msgVideoFile.delay;
          this.onVideoFileMessage(msgVideoFile);
          break;
        case 'audioFile':
          const msgAudioFile = {
            id: id,
            type: chattype,
            from: from,
            to: too,
            // url: (location.protocol != 'https:' && self.isHttpDNS) ? (self.apiUrl + msgBody.url.substr(msgBody.url.indexOf("/", 9))) : msgBody.url //@@@@@khanhduong update
            data: location.protocol != 'https:' && self.isHttpDNS ? self.apiUrl + msgBody.data.substr(msgBody.data.indexOf('/', 9)) : msgBody.data,
            secret: msgBody.secret,
            filename: msgBody.filename,
            thumb: msgBody.thumb,
            thumb_secret: msgBody.thumb_secret,
            file_length: msgBody.file_length || '',
            width: msgBody.size?.width || 0,
            height: msgBody.size?.height || 0,
            filetype: msgBody.filetype || '',
            accessToken: this.context.accessToken || '',
            ext: extmsg,
            delay: parseMsgData.delayTimeStamp,
            expts: msgBody.expts || expts,
            createdAt: msgBody.createdAt,
            isForwardedMessage: isForwardedMessage,
            time: msgBody.time,
            ...quoteMessageData,
            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
            senderMemberLevel: msgBody.senderMemberLevel,
            recvMemberLevel: msgBody.recvMemberLevel,
            isRecvMatching: msgBody.isRecvMatching,
            isSenderMatching: msgBody.isSenderMatching,
            profilePhotoComment: msgBody.profilePhotoComment,
          };
          !msgAudioFile.delay && delete msgAudioFile.delay;
          this.onAudioFileMessage(msgAudioFile);
          break;
        case 'audio':
          const msgAudio = {
            id: id,
            type: chattype,
            from: from,
            to: too,
            url: location.protocol != 'https:' && self.isHttpDNS ? self.apiUrl + msgBody.url.substr(msgBody.url.indexOf('/', 9)) : msgBody.url,
            secret: msgBody.secret,
            filename: msgBody.filename,
            length: msgBody.length || '',
            file_length: msgBody.file_length || '',
            filetype: msgBody.filetype || '',
            accessToken: this.context.accessToken || '',
            ext: extmsg,
            delay: parseMsgData.delayTimeStamp,
            data: msgBodies,
            expts: msgBody.expts || 0,
            ...quoteMessageData,
            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
          };
          !msgAudio.delay && delete msgAudio.delay;
          this.onAudioMessage(msgAudio);
          break;
        case 'file':
          const msgFile = {
            id: id,
            type: chattype,
            from: from,
            to: too,
            url: location.protocol != 'https:' && self.isHttpDNS ? self.apiUrl + msgBody.url.substr(msgBody.url.indexOf('/', 9)) : msgBody.url,
            secret: msgBody.secret,
            filename: msgBody.filename,
            file_length: msgBody.file_length,
            accessToken: this.context.accessToken || '',
            ext: extmsg,
            delay: parseMsgData.delayTimeStamp,
            expts: msgBody.expts || 0,
            ...quoteMessageData,

            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
          };
          !msgFile.delay && delete msgFile.delay;
          this.onFileMessage(msgFile);
          break;
        case 'loc':
          const msgLoc = {
            id: id,
            type: chattype,
            from: from,
            to: too,
            addr: msgBody.addr,
            lat: msgBody.lat,
            lng: msgBody.lng,
            ext: extmsg,
            delay: parseMsgData.delayTimeStamp,
            expts: msgBody.expts || 0,
            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
          };
          !msgLoc.delay && delete msgLoc.delay;
          this.onLocationMessage(msgLoc);
          break;
        case 'video':
          const msgVideo = {
            id: id,
            type: 'video',
            from: from,
            to: too,
            url: location.protocol != 'https:' && self.isHttpDNS ? self.apiUrl + msgBody.url.substr(msgBody.url.indexOf('/', 9)) : msgBody.url,
            secret: msgBody.secret,
            filename: msgBody.filename,
            file_length: msgBody.file_length,
            accessToken: this.context.accessToken || '',
            ext: extmsg,
            delay: parseMsgData.delayTimeStamp,
            requestType: msgBody.requestType,
            data: msgBody,
            expts: msgBody.expts || 0,
            time: msgBody.time,
            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
            senderMemberLevel: msgBody.senderMemberLevel,
            recvMemberLevel: msgBody.recvMemberLevel,
            isRecvMatching: msgBody.isRecvMatching,
            isSenderMatching: msgBody.isSenderMatching,
          };
          !msgVideo.delay && delete msgVideo.delay;
          this.onVideoMessage(msgVideo);
          break;
        case 'liveStream':
          const msgLiveStream = {
            id: id,
            type: 'liveStream',
            from: from,
            to: too,
            url: location.protocol != 'https:' && self.isHttpDNS ? self.apiUrl + msgBody.url.substr(msgBody.url.indexOf('/', 9)) : msgBody.url,
            secret: msgBody.secret,
            filename: msgBody.filename,
            file_length: msgBody.file_length,
            accessToken: this.context.accessToken || '',
            ext: extmsg,
            delay: parseMsgData.delayTimeStamp,
            data: msgBody,
            expts: msgBody.expts || 0,
            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
          };
          !msgLiveStream.delay && delete msgLiveStream.delay;
          this.onLiveStreamMessage(msgLiveStream);
          break;
        case 'banned':
          const msgBanned = {
            id: id,
            type: 'banned',
            from: from,
            to: too,
            accessToken: this.context.accessToken || '',
            ext: extmsg,
            delay: parseMsgData.delayTimeStamp,
            data: msgBody,
            expts: msgBody.expts || 0,
            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
          };
          !msgBanned.delay && delete msgBanned.delay;
          this.onBannedMessage(msgBanned);
          break;
        case 'blocked':
          const msgBlocked = {
            id: id,
            type: 'blocked',
            from: from,
            to: too,
            accessToken: this.context.accessToken || '',
            ext: extmsg,
            delay: parseMsgData.delayTimeStamp,
            data: msgBody,
            expts: msgBody.expts || 0,
            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
          };
          !msgBlocked.delay && delete msgBlocked.delay;
          this.onBlockedMessage(msgBlocked);
          break;
        case 'whisper':
          const msgWhisper = {
            id: id,
            type: 'whisper',
            from: from,
            to: too,
            accessToken: this.context.accessToken || '',
            ext: extmsg,
            delay: parseMsgData.delayTimeStamp,
            data: msgBody,
            expts: msgBody.expts || 0,
            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
          };
          !msgWhisper.delay && delete msgWhisper.delay;
          this.onWhisperStatus(msgWhisper);
          break;
        case 'heartMsg':
          const msgHeartMsg = {
            id: id,
            type: 'heartMsg',
            from: from,
            to: too,
            accessToken: this.context.accessToken || '',
            ext: extmsg,
            delay: parseMsgData.delayTimeStamp,
            data: msgBody.data,
            expts: msgBody.expts || 0,
            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
          };
          !msgHeartMsg.delay && delete msgHeartMsg.delay;
          this.onHeartMessage(msgHeartMsg);
          break;
        case 'link':
          const msgLink = {
            id: id,
            type: chattype,
            from: from,
            to: too,
            url: location.protocol != 'https:' && self.isHttpDNS ? self.apiUrl + msgBody.url.substr(msgBody.url.indexOf('/', 9)) : msgBody.url,
            secret: msgBody.secret,
            filename: msgBody.filename,
            file_length: msgBody.file_length,
            accessToken: this.context.accessToken || '',
            ext: extmsg,
            delay: parseMsgData.delayTimeStamp,
            data: msgBody.data,
            expts: msgBody.expts || 0,
            time: msgBody.time,
            ...quoteMessageData,
            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
          };
          !msgLink.delay && delete msgLink.delay;

          this.onLinkMessage(msgLink);
          break;

        case 'notification':
          let data = { from: from, to: too, data: msgBody.data };
          const msgNotification = {
            id: id,
            type: 'notification',
            from: from,
            to: too,
            delay: parseMsgData.delayTimeStamp,
            data: data,
            expts: msgBody.expts || 0,
            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
          };
          !msgNotification.delay && delete msgNotification.delay;
          this.onNotificationMessage(msgNotification);
          break;
        case 'cmd':
          const msgCmd = {
            id: id,
            from: from,
            to: too,
            action: msgBody.action,
            ext: extmsg,
            delay: parseMsgData.delayTimeStamp,
            expts: msgBody.expts || 0,
            error: errorBool,
            errorText: errorText,
            errorCode: errorCode,
          };
          !msgCmd.delay && delete msgCmd.delay;
          this.onCmdMessage(msgCmd);
          break;
      }

      if (self.delivery) {
        var msgId = self.getUniqueId();
        var bodyId = msg.id;
        var deliverMessage = new WebIM.message('delivery', msgId);
        deliverMessage.set({
          id: bodyId,
          to: msg.from,
        });
        self.send(deliverMessage.body);
      }
    } catch (e) {
      this.onError({
        type: _code.WEBIM_CONNCTION_CALLBACK_INNER_ERROR,
        data: e,
      });
    }
  }
};

connection.prototype.handleDeliveredMessage = function (message: Element) {
  // var id = message.id;
  // if (!id) {
  //   id = message.getAttribute('id');
  // }
  var body = message.getElementsByTagName('body');
  var mid = getMessageIdFromBodyTag(body);

  var msg = {
    mid: mid,
  };
  this.onDeliverdMessage(msg);
  /*  this.sendReceiptsMessage({
      id: id
    });*/
};

connection.prototype.handleAckedMessage = function (message: any) {
  let id = message.id || '';
  let from = message.from;
  if (!id) {
    id = message.getAttribute('id');
    from = message.getAttribute('from');
  }
  const acked = message.getElementsByTagName('acked');
  if (acked && acked.length) {
    var mid = acked[0].getAttribute('id');
    var conversationId = acked[0].getAttribute('conversationId');
    var msg = {
      mid: mid,
      from: from,
      conversationId: conversationId,
    };
    this.onReadMessage(msg);
  }

  /*  this.sendReceiptsMessage({
      id: id
    });*/
};

function getMessageIdFromBodyTag(body: HTMLCollectionOf<HTMLBodyElement>) {
  var mid = '';
  if ((body[0] && body[0].innerHTML) || (body[1] && body[1].innerHTML)) {
    if (body[0].innerHTML) mid = body[0].innerHTML;
    else mid = body[1].innerHTML;
  } else if (body[0] && body[0].childNodes && body[0].childNodes.length > 0) {
    if (body[0].childNodes[0]) {
      // @ts-ignore
      mid = body[0].childNodes[0].data;
    }
    // @ts-ignore
    else mid = body[0].childNodes[1].data;
  } else if (body[1] && body[1].childNodes && body[1].childNodes.length > 0) {
    if (body[1].childNodes[0]) {
      // @ts-ignore
      mid = body[1].childNodes[0].data;
    } else {
      // @ts-ignore
      mid = body[1].childNodes[1].data;
    }
  }
  return mid;
}

connection.prototype.handleMessageBoost = function (message: Element) {
  var boost = message.getElementsByTagName('boost');
  if (boost && boost.length) {
    let mid = boost[0].getAttribute('id');
    let _from = message.getAttribute('from') || '';
    let _conversationId = boost[0].getAttribute('conversationId') || '';
    let _expiredTime = boost[0].getAttribute('expiredTime') || '';
    var msg = {
      mid: mid,
      conversationId: _conversationId,
      from: _from,
      expiredTime: _expiredTime,
    };
    this.onMessageBoost(msg);
  }
};

connection.prototype.handleDeletedMessage = function (message: Element) {
  //console.log('debug@-onDeletedMessage', message);
  // var id = message.id;
  // var body = message.getElementsByTagName('body');
  // var mid = getMessageIdFromBodyTag(body);
  var deleted = message.getElementsByTagName('deleted');
  if (deleted && deleted.length) {
    let mid = deleted[0].getAttribute('id');
    let _isDeleteConversation = deleted[0].getAttribute('isDeleteConversation') === 'true' ? true : false;
    let _from = deleted[0].getAttribute('from') || '';
    let _conversationId = deleted[0].getAttribute('conversationId') || '';
    let _isDeclineMessage = deleted[0].getAttribute('isDeclineMessage') || '';
    let _isOpenedMessage = deleted[0].getAttribute('isOpenedMessage') || '';
    let _isAccepted = deleted[0].getAttribute('isAccepted') || '';
    var msg = {
      mid: mid,
      isDeleteConversation: _isDeleteConversation,
      conversationId: _conversationId,
      isDeclineMessage: _isDeclineMessage,
      isOpenedMessage: _isOpenedMessage,
      isAccepted: _isAccepted,
      from: _from,
    };
    this.onDeletedMessage(msg);
  }
};

connection.prototype.handleUpdatedMessage = function (message: Element) {
  let updated = message.getElementsByTagName('updated');
  let mid = getMessageIdFromBodyTag(message.getElementsByTagName('body'));
  let data;
  if (updated[0]) {
    let jsonData = updated[0].getAttribute('body') || '';
    jsonData = jsonData.replace('\n', '<br>');
    try {
      data = eval('(' + jsonData + ')');
    } catch (e) {}

    if (data) {
      let msg = {
        mid: mid,
        body: data.body.data,
      };
      this.onUpdatedMessage(msg);
    } else {
      console.log('ERROR: handleUpdatedMessage: body is empty');
    }
  }
};

connection.prototype.handleChatStateChanged = function (msgInfo: Element, chatStateType: string) {
  let msg = {
    mid: msgInfo.getAttribute('id') || '',
    type: chatStateType,
    from: msgInfo.getAttribute('from') || '',
  };

  this.onChatStateChanged(msg);
};

// connection.prototype.handleVideoMessage = function (msgInfo: any) {
//   let msg = {
//     id: msgInfo.getAttribute('id') || '',
//     to: msgInfo.getAttribute('toxmppId') || '',
//     from: msgInfo.getAttribute('fromxmppId') || '',
//     type: msgInfo.getAttribute('requestType') || '',
//     data: msgInfo.getAttribute('data') || '',
//     senderMemberLevel: parseInt(msgInfo.getAttribute('senderMemberLevel')) || 1,
//     recvMemberLevel: parseInt(msgInfo.getAttribute('recvMemberLevel')) || 1,
//     isRecvMatching: parseInt(msgInfo.getAttribute('isRecvMatching')) || 0,
//     isSenderMatching: parseInt(msgInfo.getAttribute('isSenderMatching')) || 0
//   };
//   console.log("handleVideoMessage", msgInfo)
//   this.onVideoMessage(msg);
// };

/**
 *
 * @param message
 * @param fromUserId
 * @param toMsgId
 */
connection.prototype.handleFastenDeletedMessage = function (message: any, fromUserId: string, toMsgId: string, roomJid: string) {
  this.onFastenDeleteMessage(message, fromUserId, toMsgId, roomJid);
};

connection.prototype.handleReactionMessage = function (message: any, toMsgId: string, fromUserId: string, isClear: boolean, type: string) {
  const reaction = message.childNodes[0].nodeValue;
  if (reaction && toMsgId) {
    this.onReceiveReactionMessage(reaction, toMsgId, fromUserId, isClear, type);
  }
};

connection.prototype.handleQuoteMessage = function (message: any, toMsgId: string, from: string) {
  if (message && toMsgId) {
    console.log('onReceiveQuoteMessage', message, toMsgId, from);
    this.onReceiveQuoteMessage(message, toMsgId, from);
  }
};

connection.prototype.handleFasteningMessage = function (message: Element) {
  try {
    // console.log("handleFasteningMessage message", message);
    const mid = message.getAttribute('id');
    const fastening = message.getElementsByTagName('apply-to');
    const type = message.getAttribute('type') || '';
    const from = message.getAttribute('from') || '';
    let fromUserId;
    if (type !== 'groupchat') {
      fromUserId = from.split('/')[0];
    } else {
      fromUserId = parseInt(from.split('/')[1]);
    }
    const roomJid = from.split('/')[0];
    // Should consider to handle support Interaction with stanza encryption at link https://xmpp.org/extensions/xep-0422.html#encryption
    const toMsgId = fastening[0].getAttribute('id');
    const reactions = fastening[0].getElementsByTagName('reaction');
    const retract = fastening[0].getElementsByTagName('retract');
    const isClear = fastening[0].getAttribute('clear') || false;
    if (reactions && reactions.length > 0 && reactions[0].namespaceURI === 'rhp:urn:xmpp:reaction') {
      this.handleReactionMessage(reactions[0], toMsgId, fromUserId, isClear, type);
    } else if (retract && retract.length > 0 && retract[0].namespaceURI === 'urn:xmpp:message-retract:' && isClear) {
      this.handleFastenDeletedMessage(message, fromUserId, toMsgId, roomJid);
    } else {
      this.handleMessage(message);
    }
  } catch (e) {
    console.error('handleFasteningMessage error:', e);
    this.onError({
      type: _code.WEBIM_CONNCTION_CALLBACK_INNER_ERROR,
      data: e,
    });
  }
};

connection.prototype.handleReceivedMessage = function (message: Element) {
  try {
    const received = message.getElementsByTagName('received');
    const mid = received[0].getAttribute('mid');
    const body = message.getElementsByTagName('body');
    if (!body || !body[0]) {
      console.log('Cannot handle this type of received message', message);
      return;
    }
    const id = body[0].innerHTML;
    const msg = {
      mid: mid,
      id: id,
    };
    this.onReceivedMessage(msg);
  } catch (e) {
    this.onError({
      type: _code.WEBIM_CONNCTION_CALLBACK_INNER_ERROR,
      data: e,
    });
  }
  let rcv = message.getElementsByTagName('received'),
    id = '',
    mid = '';

  if (rcv.length > 0) {
    if (rcv[0].childNodes && rcv[0].childNodes.length > 0) {
      id = rcv[0].childNodes[0].nodeValue || '';
    } else {
      id = rcv[0].innerHTML || (<HTMLElement>rcv[0])?.innerText || '';
    }
    mid = rcv[0].getAttribute('mid') || '';
  }

  if (_msgHash[id]) {
    try {
      _msgHash[id].msg.success instanceof Function && _msgHash[id].msg.success(id, mid);
    } catch (e) {
      this.onError({
        type: _code.WEBIM_CONNCTION_CALLBACK_INNER_ERROR,
        data: e,
      });
    }
    delete _msgHash[id];
  }
};

connection.prototype.handleInviteMessage = function (message: Element) {
  const inviteMsg = message.getElementsByTagName('invite');
  const reasonDom = message.getElementsByTagName('reason')[0];
  const reasonMsg = reasonDom ? reasonDom.textContent : '';
  let fromUserJid = null;
  // var id = message.getAttribute('id') || '';
  // this.sendReceiptsMessage({
  //   id: id,
  // });

  const roomjid = message.getAttribute('from') || '';
  const roomid = _parseNameFromJidFn(roomjid);

  const toUserJid = message.getAttribute('to') || '';
  const to = _parseNameFromJidFn(toUserJid);

  if (inviteMsg && inviteMsg.length > 0) {
    const from = inviteMsg[0].getAttribute('from');
    if (from) {
      fromUserJid = from.split('/')[0];
    }
  }
  // var xmsg = message.getElementsByTagName('x');
  // if (xmsg && xmsg.length > 0) {
  //   for (var i = 0; i < xmsg.length; i++) {
  //     if ('jabber.org/protocol/muc#user' === xmsg[i].namespaceURI) {
  // roomjid = xmsg[i].getAttribute('jid');
  // roomid = _parseNameFromJidFn(roomjid);
  //     }
  //   }
  // }
  this.onInviteMessage({
    type: 'invite',
    fromUserJid: fromUserJid,
    to: to,
    toUserJid: toUserJid,
    roomid: roomid,
    roomJid: roomjid,
    reason: reasonMsg,
  });
};

connection.prototype.handleMutedMessage = function (message: Element) {
  var id = message.id;
  this.onMutedMessage({
    mid: id,
  });
};

connection.prototype.sendCommand = function (dom: Element, sucFn: any, errFn: any) {
  if (this.isOpened()) {
    let id = dom.getAttribute('id') || '';
    let type = dom.getAttribute('type') || '';
    let body = dom.getElementsByTagName('body') || '';
    let _isDisplayableMessage = (type === 'chat' || type === 'groupchat') && body.length !== 0;
    let newIndex = 0;
    try {
      let lastQueueMessage = this.unAcknowledgeQueue.head();
      if (lastQueueMessage) {
        newIndex = this.unAcknowledgeQueue.head().index + 1;
      } else {
        newIndex = 1;
      }
    } catch (error) {
      console.log('newIndex', error);
    }

    // Put request into queue
    if (this.streamManagementEnabled) {
      const nextStanzasClientSendCount = this.stanzasClientSendCount + 1;

      this.queueUnacknowledgeRequest({
        x: WebIM.config.simulateSendMessageFailed && _isDisplayableMessage ? nextStanzasClientSendCount + 10 : nextStanzasClientSendCount,
        id: id,
        isDisplayableMessage: _isDisplayableMessage,
        index: newIndex,
      });

      this.stanzasClientSendCount = nextStanzasClientSendCount;
    }

    if (!WebIM.config.simulateSendMessageFailed) {
      if (sucFn || errFn) this.context.stropheConn.sendIQ(dom, sucFn, errFn);
      else this.context.stropheConn.send(dom);
    }

    if (WebIM.config.simulateSendMessageFailed && _isDisplayableMessage) WebIM.config.simulateSendMessageFailed = false;

    // After send 5 display message, send the request
    if (this.streamManagementEnabled && _isDisplayableMessage) {
      this.requestDeliveredCount = this.requestDeliveredCount + 1;
      this.requestDelivered();

      this.stanzasClientLastAckIndex = newIndex;
    }
  } else {
    this.onError({
      type: _code.WEBIM_CONNCTION_DISCONNECTED,
      reconnect: true,
    });
  }
};

connection.prototype.getUniqueId = function (prefix: any) {
  // fix: too frequently msg sending will make same id
  if (this.autoIncrement) {
    this.autoIncrement++;
  } else {
    this.autoIncrement = 1;
  }
  var cdate = new Date();
  var offdate = new Date(2010, 1, 1);
  var offset = cdate.getTime() - offdate.getTime();
  var hexd = parseFloat(String(offset)).toString(16) + this.autoIncrement;

  if (typeof prefix === 'string' || typeof prefix === 'number') {
    return prefix + '_' + hexd;
  } else {
    return 'WEBIM_' + hexd;
  }
};

connection.prototype.send = function (messageSource: any) {
  var self = this;
  var message = messageSource;
  if (message.type === 'txt') {
    if (this.encrypt.type === 'base64') {
      message = clone(messageSource);
      message.msg = _utils.btoa(message.msg);
    } else if (this.encrypt.type === 'aes') {
      message = clone(messageSource);
      var key = CryptoJS.enc.Utf8.parse(this.encrypt.key);
      var iv = CryptoJS.enc.Utf8.parse(this.encrypt.iv);
      var mode = this.encrypt.mode.toLowerCase();
      let option = {};
      if (mode === 'cbc') {
        option = {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        };
      } else if (mode === 'ebc') {
        option = {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7,
        };
      }
      var encryptedData = CryptoJS.AES.encrypt(message.msg, key, option);

      message.msg = encryptedData.toString();
    }
  }
  if (this.isWindowSDK) {
    WebIM.doQuery(
      '{"type":"sendMessage","to":"' + message.to + '","message_type":"' + message.type + '","msg":"' + encodeURI(message.msg) + '","chatType":"' + message.chatType + '"}',
      function (response: any) {},
      function (code: any, msg: any) {
        var message = {
          data: {
            data: 'send',
          },
          type: _code.WEBIM_MESSAGE_SED_ERROR,
        };
        self.onError(message);
      }
    );
  } else {
    if (Object.prototype.toString.call(message) === '[object Object]') {
      var appKey = this.context.appKey || '';
      var toJid = appKey + '_' + message.to + '@' + this.domain;

      if (message.group) {
        // toJid = message.to
        toJid = message.to;
      }
      if (message.resource) {
        toJid = toJid + '/' + message.resource;
      }
      if (message.isPrivate) {
        toJid = message.to;
      }
      message.toJid = toJid;
      message.id = message.id || this.getUniqueId();
      _msgHash[message.id] = new _message(message);
      _msgHash[message.id].send(this);
    } else if (typeof message === 'string') {
      _msgHash[message] && _msgHash[message].send(this);
    }
  }
};

connection.prototype.addRoster = function (options: any) {
  var jid = _getJid(options, this);
  var name = options.name || '';
  var groups = options.groups || '';

  // @ts-ignore
  var iq = $iq({ type: 'set' });
  iq.c('query', { xmlns: 'jabber:iq:roster' });
  iq.c('item', { jid: jid, name: name });

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      iq.c('group').t(groups[i]).up();
    }
  }
  var suc = options.success || _utils.emptyfn;
  var error = options.error || _utils.emptyfn;
  this.sendCommand(iq.tree(), suc, error);
};

connection.prototype.removeRoster = function (options: any) {
  var jid = _getJid(options, this);
  // @ts-ignore
  var iq = $iq({ type: 'set' }).c('query', { xmlns: 'jabber:iq:roster' }).c('item', {
    jid: jid,
    subscription: 'remove',
  });

  var suc = options.success || _utils.emptyfn;
  var error = options.error || _utils.emptyfn;
  this.sendCommand(iq, suc, error);
};

connection.prototype.getRoster = function (options: any) {
  var conn = this;
  // @ts-ignore
  var dom = $iq({
    type: 'get',
  }).c('query', { xmlns: 'jabber:iq:roster' });

  var options = options || {};
  var suc = options.success || this.onRoster;
  var completeFn = function (ele: any) {
    let roster: any[] = [];
    var msgBodies = ele.getElementsByTagName('query');
    if (msgBodies && msgBodies.length > 0) {
      var queryTag = msgBodies[0];
      roster = _parseFriend(queryTag);
    }
    suc(roster, ele);
  };
  var error = options.error || this.onError;
  var failFn = function (ele: any) {
    error({
      type: _code.WEBIM_CONNCTION_GETROSTER_ERROR,
      data: ele,
    });
  };
  if (this.isOpened()) {
    this.sendCommand(dom.tree(), completeFn, failFn);
  } else {
    error({
      type: _code.WEBIM_CONNCTION_DISCONNECTED,
    });
  }
};

connection.prototype.subscribe = function (options: any) {
  var jid = _getJid(options, this);
  var pres = $pres({ to: jid, type: 'subscribe' });
  if (options.message) {
    pres.c('status').t(options.message).up();
  }
  if (options.nick) {
    pres.c('nick', { xmlns: 'http://jabber.org/protocol/nick' }).t(options.nick);
  }
  this.sendCommand(pres.tree());
};

connection.prototype.subscribed = function (options: any) {
  var jid = _getJid(options, this);
  var pres = $pres({ to: jid, type: 'subscribed' });

  if (options.message) {
    pres.c('status').t(options.message).up();
  }
  this.sendCommand(pres.tree());
};

connection.prototype.unsubscribe = function (options: any) {
  var jid = _getJid(options, this);
  var pres = $pres({ to: jid, type: 'unsubscribe' });

  if (options.message) {
    pres.c('status').t(options.message);
  }
  this.sendCommand(pres.tree());
};

connection.prototype.unsubscribed = function (options: any) {
  var jid = _getJid(options, this);
  var pres = $pres({ to: jid, type: 'unsubscribed' });

  if (options.message) {
    pres.c('status').t(options.message).up();
  }
  this.sendCommand(pres.tree());
};

connection.prototype.joinPublicGroup = function (options: any) {
  var roomJid = this.context.appKey + '_' + options.roomId + '@conference.' + this.domain;
  var room_nick = roomJid + '/' + this.context.userId;
  var suc = options.success || _utils.emptyfn;
  var err = options.error || _utils.emptyfn;
  var errorFn = function (ele: any) {
    err({
      type: _code.WEBIM_CONNCTION_JOINROOM_ERROR,
      data: ele,
    });
  };
  var iq = $pres({
    from: this.context.jid,
    to: room_nick,
  }).c('x', { xmlns: Strophe.NS.MUC });

  this.sendCommand(iq.tree(), suc, errorFn);
};

connection.prototype.listRooms = function (options: any) {
  var iq = $iq({
    to: options.server || 'muc.' + this.domain,
    from: this.context.jid,
    type: 'get',
  }).c('query', { xmlns: Strophe.NS.DISCO_ITEMS });

  var suc = options.success || _utils.emptyfn;
  var error = options.error || this.onError;
  var completeFn = function (result: any) {
    var rooms = [];
    rooms = _parseRoom(result);
    try {
      suc(rooms);
    } catch (e) {
      error({
        type: _code.WEBIM_CONNCTION_GETROOM_ERROR,
        data: e,
      });
    }
  };
  var err = options.error || _utils.emptyfn;
  var errorFn = function (ele: any) {
    err({
      type: _code.WEBIM_CONNCTION_GETROOM_ERROR,
      data: ele,
    });
  };
  this.sendCommand(iq.tree(), completeFn, errorFn);
};

connection.prototype.queryRoomMember = function (options: any) {
  var domain = this.domain;
  const members: {
    jid: string;
    affiliation: string;
  }[] = [];
  var iq = $iq({
    to: options.jid,
    type: 'get',
  })
    .c('query', { xmlns: Strophe.NS.MUC + '#admin' })
    .c('item', { affiliation: 'member' });

  var suc = options.success || _utils.emptyfn;
  var completeFn = function (result: Element) {
    var items = result.getElementsByTagName('item');

    if (items) {
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var mem = {
          jid: item.getAttribute('jid') || '',
          affiliation: 'member',
        };
        members.push(mem);
      }
    }
    suc(members);
  };
  var err = options.error || _utils.emptyfn;
  var errorFn = function (ele: any) {
    err({
      type: _code.WEBIM_CONNCTION_GETROOMMEMBER_ERROR,
      data: ele,
    });
  };
  this.sendCommand(iq.tree(), completeFn, errorFn);
};

connection.prototype.queryRoomInfo = function (options: any) {
  if (!this.isOpened()) {
    console.log('ERROR: NOT CONNECTION TO queryRoomInfo');
    return;
  }
  var domain = this.domain;
  var iq = $iq({
    to: options.roomJid,
    type: 'get',
  }).c('query', { xmlns: Strophe.NS.DISCO_INFO });

  var suc = options.success || _utils.emptyfn;
  var members: {
    jid: string;
    affiliation: string;
  }[] = [];

  var completeFn = function (result: Element) {
    var settings = '';
    var features = result.getElementsByTagName('feature');
    if (features) {
      settings = features[1].getAttribute('var') + '|' + features[3].getAttribute('var') + '|' + features[4].getAttribute('var');
    }
    switch (settings) {
      case 'muc_public|muc_membersonly|muc_notallowinvites':
        settings = 'PUBLIC_JOIN_APPROVAL';
        break;
      case 'muc_public|muc_open|muc_notallowinvites':
        settings = 'PUBLIC_JOIN_OPEN';
        break;
      case 'muc_hidden|muc_membersonly|muc_allowinvites':
        settings = 'PRIVATE_MEMBER_INVITE';
        break;
      case 'muc_hidden|muc_membersonly|muc_notallowinvites':
        settings = 'PRIVATE_OWNER_INVITE';
        break;
    }
    var owner = '';
    var fields = result.getElementsByTagName('field');
    const fieldValues: any = {};
    if (fields) {
      for (var i = 0; i < fields.length; i++) {
        var field: any = fields[i];
        var fieldVar = field.getAttribute('var');
        var fieldSimplify = fieldVar?.split('_')[1] || '';
        switch (fieldVar) {
          case 'muc#roominfo_occupants':
          case 'muc#roominfo_maxusers':
          case 'muc#roominfo_affiliations':
          case 'muc#roominfo_description':
          case 'muc#roomconfig_roomowners':
            fieldValues[fieldSimplify] = field.textContent || field.text || '';
            break;
          case 'muc#roominfo_owner':
            var mem = {
              jid: (field.textContent || field.text) + '@' + domain,
              affiliation: 'owner',
            };
            members.push(mem);
            fieldValues[fieldSimplify] = field.textContent || field.text;
            break;
        }

        // if (field.getAttribute('label') === 'owner') {
        //     var mem = {
        //         jid: (field.textContent || field.text) + '@' + domain
        //         , affiliation: 'owner'
        //     };
        //     members.push(mem);
        //     break;
        // }
      }
      fieldValues['name'] = result.getElementsByTagName('identity')[0].getAttribute('name');
    }

    suc(settings, members, fieldValues);
  };
  var err = options.error || _utils.emptyfn;
  var errorFn = function (ele: any) {
    err({
      type: _code.WEBIM_CONNCTION_GETROOMINFO_ERROR,
      data: ele,
    });
  };
  this.sendCommand(iq.tree(), completeFn, errorFn);
};

connection.prototype.queryRoomOccupants = function (options: any) {
  if (!this.isOpened()) {
    console.log('ERROR: NOT CONNECTION TO queryRoomOccupants');
    return;
  }
  // console.log("queryRoomOccupants", options)
  var suc = options.success || _utils.emptyfn;
  var completeFn = function (result: any) {
    var occupants = [];
    occupants = _parseRoomOccupants(result);
    suc(occupants);
  };
  var err = options.error || _utils.emptyfn;
  var errorFn = function (ele: any) {
    err({
      type: _code.WEBIM_CONNCTION_GETROOMOCCUPANTS_ERROR,
      data: ele,
    });
  };
  var attrs = {
    xmlns: Strophe.NS.DISCO_ITEMS,
  };
  var info = $iq({
    from: this.context.jid,
    //to: this.context.appKey + '_' + options.jid + '@conference.' + this.domain,
    to: options.roomJid,
    type: 'get',
  }).c('query', attrs);
  this.sendCommand(info.tree(), completeFn, errorFn);
};

connection.prototype.setUserSig = function (desc: string) {
  var dom = $pres({ xmlns: 'jabber:client' });
  desc = desc || '';
  dom.c('status').t(desc);
  this.sendCommand(dom.tree());
};

connection.prototype.setPresence = function (type: string, status: string) {
  var dom = $pres({ xmlns: 'jabber:client' });
  if (type) {
    if (status) {
      dom.c('show').t(type);
      dom.up().c('status').t(status);
    } else {
      dom.c('show').t(type);
    }
  }
  this.sendCommand(dom.tree());
};

connection.prototype.setInvisible = function () {
  var dom = $pres({ xmlns: 'jabber:client', type: 'invisible' });
  this.sendCommand(dom.tree());
};

connection.prototype.enableStreamManagement = function () {
  var dom = $build('enable', { xmlns: 'urn:xmpp:sm:3' });
  // DO NOT USE this.sendCommand
  this.context.stropheConn.send(dom.tree());
};

connection.prototype.discoRoom = function () {
  var dom = $iq({ type: 'get', to: this.domain });
  dom.c('query', { xmlns: 'http://jabber.org/protocol/disco#info' });
  this.sendCommand(dom.tree());
};

connection.prototype.requestDelivered = function () {
  var dom = $build('r', { xmlns: 'urn:xmpp:sm:3' });
  // DO NOT USE this.sendCommand
  this.context.stropheConn.send(dom.tree());

  if (this.requestDeliveredTimeout) {
    clearTimeout(this.requestDeliveredTimeout);
  }
  this.requestDeliveredTimeout = setTimeout(() => {
    clearTimeout(this.requestDeliveredTimeout);
    this.requestDeliveredTimeout = null;

    if (typeof this.onRequestDeliveredTimeout === 'function') {
      this.onRequestDeliveredTimeout();
    }
  }, WebIM.config.requestDeliveredTimeout);
};

// Enabling Carbons xep-0280
connection.prototype.setCarbons = function () {
  var dom = $iq({ type: 'set', from: this.context.jid, id: 'setCarbons' });
  dom.c('enable', { xmlns: 'urn:xmpp:carbons:2' });
  this.sendCommand(dom.tree());
};

connection.prototype.getPresence = function () {
  var dom = $pres({ xmlns: 'jabber:client' });
  var conn = this;
  this.sendCommand(dom.tree());
};

connection.prototype.ping = function (pingOptions: any) {
  const options = pingOptions || {};
  // var me = this;
  const jid = _getJid(options, this);
  const dom = $iq({
    from: this.context.jid || '',
    to: jid,
    type: 'get',
  }).c('ping', { xmlns: 'urn:xmpp:ping' });

  const suc = options.success || _utils.emptyfn;
  const error = options.error || this.onError;
  const timeoutFunctionCallback = () => {
    // this.addLogService(`timeoutFunctionCallback: ${options.onPingTimeout}`);
    if (options.onPingTimeout) {
      options.onPingTimeout();
    }
  };
  const failFn = (ele: any) => {
    if (this.pingTimeoutID) {
      // this.addLogService(`clearTimeout pingTimeoutID in failFn: ${this.pingTimeoutID}`);
      clearTimeout(this.pingTimeoutID);
      this.pingTimeoutID = null;
    }
    error({
      type: _code.WEBIM_CONNCTION_PING_ERROR,
      data: ele,
    });
  };
  if (this.isOpened()) {
    this.sendCommand(dom.tree(), suc, failFn);
    if (!this.pingTimeoutID) {
      this.pingTimeoutID = setTimeout(() => {
        // this.addLogService(`clearTimeout pingTimeoutID: ${this.pingTimeoutID}`);
        clearTimeout(this.pingTimeoutID);
        this.pingTimeoutID = null;
        this._onPingTimeout(timeoutFunctionCallback);
      }, this.pingTimeout);
      // this.addLogService(`setTimeout pingTimeoutID: ${this.pingTimeoutID}`);
    }
  } else {
    error({
      type: _code.WEBIM_CONNCTION_DISCONNECTED,
    });
  }
};

// connection.prototype.getStatusNow = function () {
//   return this.context.status_now;
// };
//
// connection.prototype.getStatus = function () {
//   return this.context.status;
// };

connection.prototype.isOpened = function () {
  return this.context.status == _code.STATUS_OPENED;
};

connection.prototype.isOpening = function () {
  var status = this.context.status;
  return status == _code.STATUS_DOLOGIN_USERGRID || status == _code.STATUS_DOLOGIN_IM;
};

connection.prototype.isClosing = function () {
  return this.context.status == _code.STATUS_CLOSING;
};

connection.prototype.isClosed = function () {
  return this.context.status == _code.STATUS_CLOSED;
};

connection.prototype.clear = function () {
  var key = this.context.appKey;
  if (this.errorType != _code.WEBIM_CONNCTION_DISCONNECTED) {
    this.context = {
      status: _code.STATUS_INIT,
      appKey: key,
    };
  }
  if (this.intervalId) {
    clearInterval(this.intervalId);
  }

  this.restIndex = 0;
  this.xmppIndex = 0;

  if (this.errorType == _code.WEBIM_CONNCTION_CLIENT_LOGOUT || this.errorType == -1) {
    var message = {
      data: {
        data: 'logout',
      },
      type: _code.WEBIM_CONNCTION_CLIENT_LOGOUT,
    };
    this.onError(message);
  }
};

connection.prototype.getChatRooms = function (options: any) {
  if (!_utils.isCanSetRequestHeader) {
    conn.onError({
      type: _code.WEBIM_CONNCTION_NOT_SUPPORT_CHATROOM_ERROR,
    });
    return;
  }

  var conn = this,
    token = options.accessToken || this.context.accessToken;

  if (token) {
    var apiUrl = options.apiUrl;
    var appName = this.context.appName;
    var orgName = this.context.orgName;

    if (!appName || !orgName) {
      conn.onError({
        type: _code.WEBIM_CONNCTION_AUTH_ERROR,
      });
      return;
    }

    var suc = function (data: any, xhr: any) {
      typeof options.success === 'function' && options.success(data);
    };

    var error = function (res: any, xhr: any, msg: any) {
      if (res.error && res.error_description) {
        conn.onError({
          type: _code.WEBIM_CONNCTION_LOAD_CHATROOM_ERROR,
          msg: res.error_description,
          data: res,
          xhr: xhr,
        });
      }
    };

    var pageInfo = {
      pagenum: parseInt(options.pagenum) || 1,
      pagesize: parseInt(options.pagesize) || 20,
    };

    var opts = {
      url: apiUrl + '/' + orgName + '/' + appName + '/chatrooms',
      dataType: 'json',
      type: 'GET',
      headers: { Authorization: 'Bearer ' + token },
      data: pageInfo,
      success: suc || _utils.emptyfn,
      error: error || _utils.emptyfn,
    };
    _utils.ajax(opts);
  } else {
    conn.onError({
      type: _code.WEBIM_CONNCTION_TOKEN_NOT_ASSIGN_ERROR,
    });
  }
};

connection.prototype.joinChatRoom = function (options: any) {
  if (!this.isOpened()) {
    console.log('ERROR: NOT CONNECTION TO joinChatRoom');
    return;
  }
  var roomJid = options.roomJid;
  var isPublicLiveStream = options.isPublicLiveStream || false;
  var isOwnerPublicLiveStream = options.isOwnerPublicLiveStream || false;
  // var roomJid = options.roomJid;
  var room_nick = roomJid + '/' + this.context.userId;
  var suc = options.success || _utils.emptyfn;
  var err = options.error || _utils.emptyfn;
  var errorFn = function (ele: any) {
    console.log('fail');
    err({
      type: _code.WEBIM_CONNCTION_JOINCHATROOM_ERROR,
      data: ele,
    });
  };
  var successFn = function () {
    suc(true);
  };
  var iq = $pres({
    from: this.context.jid,
    to: room_nick,
  }).c('x', { xmlns: Strophe.NS.MUC });
  if (isPublicLiveStream) {
    iq.c('item', {
      isPublicLiveStream: 'true',
      isOwnerPublicLiveStream: 'true',
    });
  } else {
    iq.c('item', {});
  }

  const useHistory = options.historyChat || false;
  if (useHistory) {
    iq.up().c('history', { seconds: this.limitSecondTimeGetGroupChatMessage });
  } else {
    iq.up().c('history', { maxchars: 0 });
  }

  this.sendCommand(iq.tree(), successFn, errorFn);
};

connection.prototype.quitChatRoom = function (options: any) {
  if (!this.isOpened()) {
    console.log('ERROR: NOT CONNECTION TO QUIT CHATROOM');
    return;
  }
  var roomJid = options.roomJid;
  // var isPublicLiveStream = options.isPublicLiveStream || false;
  var room_nick = roomJid + '/' + this.context.userId;
  var suc = options.success || _utils.emptyfn;
  var err = options.error || _utils.emptyfn;
  var errorFn = function (ele: any) {
    err({
      type: _code.WEBIM_CONNCTION_QUITCHATROOM_ERROR,
      data: ele,
    });
  };
  var iq = $pres({
    from: this.context.jid,
    to: room_nick,
    type: 'unavailable',
  })
    .c('x', { xmlns: Strophe.NS.MUC + '#user' })
    .c('item', { affiliation: 'none', role: 'none' });

  // if (isPublicLiveStream) {
  //   iq.c('item', { affiliation: 'none', role: 'none', isPublicLiveStream: "true" });
  // } else {
  //   iq.c('item', { affiliation: 'none', role: 'none' })
  // };
  this.sendCommand(iq.tree(), suc, errorFn);
};

connection.prototype._onReceiveInviteFromGroup = function (info: any) {
  info = eval('(' + info + ')');
  var self = this;
  var options = {
    title: 'Group invitation',
    msg: info.user + ' invites you to join into group:' + info.group_id,
    agree: function agree() {
      WebIM.doQuery(
        '{"type":"acceptInvitationFromGroup","id":"' + info.group_id + '","user":"' + info.user + '"}',
        function (response: any) {},
        function (code: any, msg: any) {
          var message = {
            data: {
              data: 'acceptInvitationFromGroup error:' + msg,
            },
            type: _code.WEBIM_CONNECTION_ACCEPT_INVITATION_FROM_GROUP,
          };
          self.onError(message);
        }
      );
    },
    reject: function reject() {
      WebIM.doQuery(
        '{"type":"declineInvitationFromGroup","id":"' + info.group_id + '","user":"' + info.user + '"}',
        function (response: any) {},
        function (code: any, msg: any) {
          var message = {
            data: {
              data: 'declineInvitationFromGroup error:' + msg,
            },
            type: _code.WEBIM_CONNECTION_DECLINE_INVITATION_FROM_GROUP,
          };
          self.onError(message);
        }
      );
    },
  };

  this.onConfirmPop(options);
};

connection.prototype._onReceiveInviteAcceptionFromGroup = function (info: any) {
  info = eval('(' + info + ')');
  var options = {
    title: 'Group invitation response',
    msg: info.user + ' agreed to join into group:' + info.group_id,
    agree: function agree() {},
  };
  this.onConfirmPop(options);
};

connection.prototype._onReceiveInviteDeclineFromGroup = function (info: any) {
  info = eval('(' + info + ')');
  var options = {
    title: 'Group invitation response',
    msg: info.user + ' rejected to join into group:' + info.group_id,
    agree: function agree() {},
  };
  this.onConfirmPop(options);
};

connection.prototype._onAutoAcceptInvitationFromGroup = function (info: any) {
  info = eval('(' + info + ')');
  var options = {
    title: 'Group invitation',
    msg: 'You had joined into the group:' + info.group_name + ' automatically.Inviter:' + info.user,
    agree: function agree() {},
  };
  this.onConfirmPop(options);
};

connection.prototype._onLeaveGroup = function (info: any) {
  info = eval('(' + info + ')');
  var options = {
    title: 'Group notification',
    msg: 'You have been out of the group:' + info.group_id + '.Reason:' + info.msg,
    agree: function agree() {},
  };
  this.onConfirmPop(options);
};

connection.prototype._onReceiveJoinGroupApplication = function (info: any) {
  info = eval('(' + info + ')');
  var self = this;
  var options = {
    title: 'Group join application',
    msg: info.user + ' applys to join into group:' + info.group_id,
    agree: function agree() {
      WebIM.doQuery(
        '{"type":"acceptJoinGroupApplication","id":"' + info.group_id + '","user":"' + info.user + '"}',
        function (response: any) {},
        function (code: any, msg: any) {
          var message = {
            data: {
              data: 'acceptJoinGroupApplication error:' + msg,
            },
            type: _code.WEBIM_CONNECTION_ACCEPT_JOIN_GROUP,
          };
          self.onError(message);
        }
      );
    },
    reject: function reject() {
      WebIM.doQuery(
        '{"type":"declineJoinGroupApplication","id":"' + info.group_id + '","user":"' + info.user + '"}',
        function (response: any) {},
        function (code: any, msg: any) {
          var message = {
            data: {
              data: 'declineJoinGroupApplication error:' + msg,
            },
            type: _code.WEBIM_CONNECTION_DECLINE_JOIN_GROUP,
          };
          self.onError(message);
        }
      );
    },
  };
  this.onConfirmPop(options);
};

connection.prototype._onReceiveAcceptionFromGroup = function (info: any) {
  info = eval('(' + info + ')');
  var options = {
    title: 'Group notification',
    msg: 'You had joined into the group:' + info.group_name + '.',
    agree: function agree() {},
  };
  this.onConfirmPop(options);
};

connection.prototype._onReceiveRejectionFromGroup = function (info: any) {
  info = eval('(' + info + ')');
  var options = {
    title: 'Group notification',
    msg: 'You have been rejected to join into the group:' + info.group_name + '.',
    agree: function agree() {},
  };
  this.onConfirmPop(options);
};

connection.prototype._onUpdateMyGroupList = function (options: any) {
  this.onUpdateMyGroupList(options);
};

connection.prototype._onUpdateMyRoster = function (options: any) {
  this.onUpdateMyRoster(options);
};

connection.prototype.resetReconnectNumTotal = function () {
  this.autoReconnectNumTotal = 0;
};

connection.prototype.reconnect = function () {
  // Clear pingTimeout when do reconnect
  // this.addLogService(`clearTimeout in reconnect pingTimeoutID: ${this.pingTimeoutID}`);
  clearTimeout(this.pingTimeoutID);
  this.pingTimeoutID = null;
  var that = this;
  setTimeout(
    function () {
      // that.addLogService('reconnect');
      _login(that.context.restTokenData, that);
    },
    (this.autoReconnectNumTotal === 0 ? 0 : this.autoReconnectInterval) * 1000
  );
  this.autoReconnectNumTotal++;
};

connection.prototype.closed = function () {
  var message = {
    data: {
      data: 'Closed error',
    },
    type: _code.WEBIM_CONNECTION_CLOSED,
  };
  this.onError(message);
};

// used for blacklist
function _parsePrivacy(iq: Element) {
  var list: any[] = [];
  var items = iq.getElementsByTagName('item');

  if (items) {
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var jid = item.getAttribute('value');
      var order = item.getAttribute('order');
      var type = item.getAttribute('type');
      if (!jid) {
        continue;
      }
      const n = _parseNameFromJidFn(jid);
      list[parseInt(n)] = {
        type: type,
        order: order,
        jid: jid,
        name: n,
      };
    }
  }
  return list;
}

// used for blacklist
connection.prototype.getBlacklist = function (options: any) {
  options = options || {};
  var iq = $iq({ type: 'get' });
  var sucFn = options.success || _utils.emptyfn;
  var errFn = options.error || _utils.emptyfn;
  var me = this;

  iq.c('query', { xmlns: 'jabber:iq:privacy' }).c('list', { name: 'special' });
  this.sendCommand(
    iq.tree(),
    function (iq: Element) {
      me.onBlacklistUpdate(_parsePrivacy(iq));
      sucFn();
    },
    function () {
      me.onBlacklistUpdate([]);
      errFn();
    }
  );
};

// used for blacklist
connection.prototype.addToBlackList = function (options: any) {
  const iq = $iq({ type: 'set' });
  const blacklist = options.list || {};
  const type = options.type || 'jid';
  const sucFn = options.success || _utils.emptyfn;
  const errFn = options.error || _utils.emptyfn;
  let piece = iq.c('query', { xmlns: 'jabber:iq:privacy' }).c('list', { name: 'special' });

  const keys = Object.keys(blacklist);
  const len = keys.length;
  let order = 2;

  for (let i = 0; i < len; i++) {
    const item = blacklist[keys[i]];
    const type = item.type || 'jid';
    const jid = item.jid;

    piece = piece.c('item', { action: 'deny', order: order++, type: type, value: jid }).c('message');
    if (i !== len - 1) {
      piece = piece.up().up();
    }
  }

  // console.log('addToBlackList', blacklist, piece.tree());
  this.sendCommand(piece.tree(), sucFn, errFn);
};

// used for blacklist
connection.prototype.removeFromBlackList = function (options: any) {
  var iq = $iq({ type: 'set' });
  var blacklist = options.list || {};
  var sucFn = options.success || _utils.emptyfn;
  var errFn = options.error || _utils.emptyfn;
  var piece = iq.c('query', { xmlns: 'jabber:iq:privacy' }).c('list', { name: 'special' });

  var keys = Object.keys(blacklist);
  var len = keys.length;

  for (var i = 0; i < len; i++) {
    var item = blacklist[keys[i]];
    var type = item.type || 'jid';
    var jid = item.jid;
    var order = item.order;

    piece = piece.c('item', { action: 'deny', order: order, type: type, value: jid }).c('message');
    if (i !== len - 1) {
      piece = piece.up().up();
    }
  }

  // console.log('removeFromBlackList', blacklist, piece.tree());
  this.sendCommand(piece.tree(), sucFn, errFn);
};

connection.prototype._getGroupJid = function (to: string) {
  return to + '@muc.' + this.domain;
};

// used for blacklist
connection.prototype.addToGroupBlackList = function (options: any) {
  var sucFn = options.success || _utils.emptyfn;
  var errFn = options.error || _utils.emptyfn;
  var jid = _getJid(options, this);
  var affiliation = 'admin'; //options.affiliation || 'admin';
  var to = this._getGroupJid(options.roomId);
  var iq = $iq({ type: 'set', to: to });

  iq.c('query', { xmlns: 'http://jabber.org/protocol/muc#' + affiliation }).c('item', {
    affiliation: 'outcast',
    jid: jid,
  });
  this.sendCommand(iq.tree(), sucFn, errFn);
};

function _parseGroupBlacklist(iq: Element) {
  const list = [];
  const items = iq.getElementsByTagName('item');

  if (items) {
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const jid = item.getAttribute('jid');
      const affiliation = item.getAttribute('affiliation');
      const nick = item.getAttribute('nick');
      if (!jid) {
        continue;
      }
      const n = _parseNameFromJidFn(jid);
      list[parseInt(n)] = {
        jid: jid,
        affiliation: affiliation,
        nick: nick,
        name: n,
      };
    }
  }
  return list;
}

// used for blacklist
connection.prototype.getGroupBlacklist = function (options: any) {
  var sucFn = options.success || _utils.emptyfn;
  var errFn = options.error || _utils.emptyfn;

  // var jid = _getJid(options, this);
  var affiliation = 'admin'; //options.affiliation || 'admin';
  var to = this._getGroupJid(options.roomId);
  var iq = $iq({ type: 'get', to: to });

  iq.c('query', { xmlns: 'http://jabber.org/protocol/muc#' + affiliation }).c('item', {
    affiliation: 'outcast',
  });
  this.sendCommand(
    iq.tree(),
    function (msginfo: Element) {
      sucFn(_parseGroupBlacklist(msginfo));
    },
    function () {
      errFn();
    }
  );
};

// used for blacklist
connection.prototype.removeGroupMemberFromBlacklist = function (options: any) {
  var sucFn = options.success || _utils.emptyfn;
  var errFn = options.error || _utils.emptyfn;

  var jid = _getJid(options, this);
  var affiliation = 'admin'; //options.affiliation || 'admin';
  var to = this._getGroupJid(options.roomId);
  var iq = $iq({ type: 'set', to: to });

  iq.c('query', { xmlns: 'http://jabber.org/protocol/muc#' + affiliation }).c('item', {
    affiliation: 'none',
    jid: jid,
  });
  this.sendCommand(
    iq.tree(),
    function (msginfo: Element) {
      sucFn();
    },
    function () {
      errFn();
    }
  );
};

/**
 * changeGroupSubject update group subject
 *
 * @param options
 */
// <iq to='hyphenatedemo#chatdemoui_roomid@conference.hyphenate.io' type='set' id='3940489311' xmlns='jabber:client'>
//     <query xmlns='http://jabber.org/protocol/muc#owner'>
//         <x type='submit' xmlns='jabber:x:data'>
//             <field var='FORM_TYPE'><value>http://jabber.org/protocol/muc#roomconfig</value></field>
//             <field var='muc#roomconfig_roomname'><value>Room Name</value></field>
//         </x>
//     </query>
// </iq>
connection.prototype.changeGroupSubject = function (options: any) {
  var sucFn = options.success || _utils.emptyfn;
  var errFn = options.error || _utils.emptyfn;

  // must be `owner`
  var affiliation = 'owner';
  var to = this._getGroupJid(options.roomId);
  var iq = $iq({ type: 'set', to: to });

  iq.c('query', { xmlns: 'http://jabber.org/protocol/muc#' + affiliation })
    .c('x', { type: 'submit', xmlns: 'jabber:x:data' })
    .c('field', { var: 'FORM_TYPE' })
    .c('value')
    .t('http://jabber.org/protocol/muc#roomconfig')
    .up()
    .up()
    .c('field', { var: 'muc#roomconfig_roomname' })
    .c('value')
    .t(options.subject)
    .up()
    .up()
    .c('field', { var: 'muc#roomconfig_roomdesc' })
    .c('value')
    .t(options.description);

  this.sendCommand(
    iq.tree(),
    function (msginfo: Element) {
      sucFn();
    },
    function () {
      errFn();
    }
  );
};

/**
 * destroyGroup destroy group
 *
 * @param options
 */
// <iq id="9BEF5D20-841A-4048-B33A-F3F871120E58" to="hyphenatedemo#chatdemoui_1477462231499@conference.hyphenate.io" type="set">
//     <query xmlns="http://jabber.org/protocol/muc#owner">
//         <destroy>
//             <reason>xxx destory group yyy</reason>
//         </destroy>
//     </query>
// </iq>
connection.prototype.destroyGroup = function (options: any) {
  // console.log("destroyGroup", options);
  if (!this.isOpened()) {
    console.log('ERROR: NOT CONNECTION TO destroyGroup');
    return;
  }
  var sucFn = options.success || _utils.emptyfn;
  var errFn = options.error || _utils.emptyfn;

  // must be `owner`
  var affiliation = 'owner';
  var to = options.roomJid;
  const from = _getJidByName(options.name, this);
  var iq = $iq({
    type: 'set',
    to: to,
    from: from,
  });

  iq.c('query', { xmlns: 'http://jabber.org/protocol/muc#' + affiliation })
    .c('destroy', { jid: to })
    .c('reason')
    .t(options.reason || '');
  this.sendCommand(
    iq.tree(),
    function (msginfo: Element) {
      sucFn(msginfo);
    },
    function (e: any) {
      errFn(e);
    }
  );
};

/**
 * leaveGroupBySelf user left the group voluntarily
 *
 * @param options
 */
// <iq id="5CD33172-7B62-41B7-98BC-CE6EF840C4F6_hyphenate_occupants_change_affiliation" to="hyphenatedemo#chatdemoui_1477481609392@conference.hyphenate.io" type="set">
//     <query xmlns="http://jabber.org/protocol/muc#admin">
//         <item affiliation="none" jid="hyphenatedemo#chatdemoui_lwz2@hyphenate.io"/>
//     </query>
// </iq>
// <presence to="easemob-demo#chatdemoui_1479811172349@conference.easemob.com/mt002" type="unavailable"/>

connection.prototype.leaveGroupBySelf = function (options: any) {
  var self = this;
  var sucFn = options.success || _utils.emptyfn;
  var errFn = options.error || _utils.emptyfn;

  // must be `owner`
  var jid = _getJid(options, this);
  var affiliation = 'admin';
  var to = options.roomJid || this._getGroupJid(options.roomId);
  const deleteMessages = options.deleteMessages || false;
  var iq = $iq({ type: 'set', to: to });

  iq.c('query', { xmlns: 'http://jabber.org/protocol/muc#' + affiliation }).c('item', {
    affiliation: 'none',
    jid: jid,
  });
  this.sendCommand(
    iq.tree(),
    function (msgInfo: any) {
      sucFn(msgInfo);
      var pres = $pres({
        type: 'unavailable',
        to: to + '/' + self.context.userId,
      });
      self.sendCommand(pres.tree());
    },
    function (errInfo: any) {
      errFn(errInfo);
    }
  );
};

/**
 * leaveGroup member removed from group by admin
 *
 * @param options
 */
// <iq id="9fb25cf4-1183-43c9-961e-9df70e300de4:sendIQ" to="hyphenatedemo#chatdemoui_1477481597120@conference.hyphenate.io" type="set" xmlns="jabber:client">
//     <query xmlns="http://jabber.org/protocol/muc#admin">
//         <item affiliation="none" nick="hyphenatedemo#chatdemoui_lwz4@hyphenate.io"/>
//         <item nick="hyphenatedemo#chatdemoui_lwz4@hyphenate.io" role="none"/>
//         <item affiliation="none" nick="hyphenatedemo#chatdemoui_lwz2@hyphenate.io"/>
//         <item nick="hyphenatedemo#chatdemoui_lwz2@hyphenate.io" role="none"/>
//     </query>
// </iq>
connection.prototype.leaveGroup = function (options: any) {
  // console.log("options", options);
  var sucFn = options.success || _utils.emptyfn;
  var errFn = options.error || _utils.emptyfn;
  var list = options.list || [];
  var affiliation = 'admin';
  var to = options.roomJid || this._getGroupJid(options.roomId);
  // console.log("to", to);
  // @ts-ignore
  var iq = $iq({ type: 'set', to: to });
  var piece = iq.c('query', {
    xmlns: 'http://jabber.org/protocol/muc#' + affiliation,
  });
  var len = list.length;

  for (var i = 0; i < len; i++) {
    var name = list[i];
    var jid = _getJidByName(name, this);

    piece = piece
      // .c('item', {
      //   affiliation: 'none',
      //   jid: jid,
      // })
      // .up()
      .c('item', {
        role: 'none',
        nick: jid,
      })
      .c('reason')
      .t(options.reason || '')
      .up()
      .up();
  }
  this.sendCommand(
    iq.tree(),
    function (msgInfo: any) {
      sucFn(msgInfo);
    },
    function (errInfo: any) {
      errFn(errInfo);
    }
  );
};

/**
 * addGroupMembers add group member
 *
 * @param options

 message sequence: message first (group member sends one message each), then IQ (can use single IQ for multiple group members' messages)
 <!-- add group member event：send -->
 <message to='hyphenatedemo#chatdemoui_1477482739698@conference.hyphenate.io'>
 <x xmlns='http://jabber.org/protocol/muc#user'>
 <invite to='hyphenatedemo#chatdemoui_lwz2@hyphenate.io'>
 <reason>Orange invite you to join group 'hello'</reason>
 </invite>
 </x>
 </message>
 <!-- add group member：send -->
 <iq id='09DFB1E5-C939-4C43-B5A7-8000DA0E3B73_hyphenate_occupants_change_affiliation' to='hyphenatedemo#chatdemoui_1477482739698@conference.hyphenate.io' type='set'>
 <query xmlns='http://jabber.org/protocol/muc#admin'>
 <item affiliation='member' jid='hyphenatedemo#chatdemoui_lwz2@hyphenate.io'/>
 </query>
 </iq>
 */

connection.prototype.addGroupMembers = function (options: any) {
  var sucFn = options.success || _utils.emptyfn;
  var errFn = options.error || _utils.emptyfn;
  var list = options.list || [];
  // var affiliation = 'admin';
  var to = options.roomJid || this._getGroupJid(options.roomId);
  // var iq = $iq({ type: 'set', to: to });
  // var piece = iq.c('query', {
  //   xmlns: 'http://jabber.org/protocol/muc#' + affiliation,
  // });
  var len = list.length;

  for (var i = 0; i < len; i++) {
    var name = list[i];
    var jid = _getJidByName(name, this);

    // piece = piece
    //   .c('item', {
    //     affiliation: 'member',
    //     jid: jid,
    //   })
    //   .up();

    // @ts-ignore
    var dom = $msg({
      to: to,
    })
      .c('x', {
        xmlns: 'http://jabber.org/protocol/muc#user',
      })
      .c('invite', {
        to: jid,
      })
      .c('reason')
      .t(options.reason || '');

    this.sendCommand(dom.tree());
  }
  // this.sendCommand(
  //   iq.tree(),
  //   function (msgInfo: any) {
  //     sucFn(msgInfo);
  //   },
  //   function (errInfo: any) {
  //     errFn(errInfo);
  //   }
  // );
};

/**
 * acceptInviteFromGroup accept group invitation
 *
 * @param options
 */
connection.prototype.acceptInviteFromGroup = function (options: any) {
  options.success = function () {
    // then send sendAcceptInviteMessage
    // connection.prototype.sendAcceptInviteMessage(optoins);
  };
  this.addGroupMembers(options);
};

/**
 * rejectInviteFromGroup decline group invitation
 *
 * ignore request for now, not processing it
 *
 <message to='hyphenatedemo#chatdemoui_mt002@hyphenate.io' from='hyphenatedemo#chatdemoui_mt001@hyphenate.io' id='B83B7210-BCFF-4DEE-AB28-B9FE5579C1E2'>
 <x xmlns='http://jabber.org/protocol/muc#user'>
 <apply to='hyphenatedemo#chatdemoui_groupid1@conference.hyphenate.io' from='easmeob-demo#chatdemoui_mt001@hyphenate.io' toNick='llllll'>
 <reason>reject</reason>
 </apply>
 </x>
 </message>
 *
 * @param options
 */
connection.prototype.rejectInviteFromGroup = function (options: any) {
  // var from = _getJidByName(options.from, this);
  // var dom = $msg({
  //     from: from,
  //     to: _getJidByName(options.to, this)
  // }).c('x', {
  //     xmlns: 'http://jabber.org/protocol/muc#user'
  // }).c('apply', {
  //     from: from,
  //     to: this._getGroupJid(options.groupId),
  //     toNick: options.groupName
  // }).c('reason').t(options.reason || '');
  //
  // this.sendCommand(dom.tree());
};

connection.prototype.createGroupAsync = function (p: any) {
  var roomId = p.from;
  var me = this;
  var toRoom = this._getGroupJid(roomId);
  var to = toRoom + '/' + this.context.userId;
  var options = this.groupOption;
  var suc = p.success || _utils.emptyfn;

  // Creating a Reserved Room
  // @ts-ignore
  var iq = $iq({ type: 'get', to: toRoom }).c('query', {
    xmlns: 'http://jabber.org/protocol/muc#owner',
  });

  // Strophe.info('step 1 ----------');
  // Strophe.info(options);
  me.context.stropheConn.sendIQ(
    iq.tree(),
    function (msgInfo: any) {
      // console.log(msgInfo);

      // for ie hack
      if ('setAttribute' in msgInfo) {
        // Strophe.info('step 3 ----------');
        var x = msgInfo.getElementsByTagName('x')[0];
        x.setAttribute('type', 'submit');
      } else {
        // Strophe.info('step 4 ----------');
        Strophe.forEachChild(msgInfo, 'x', function (field: Element) {
          field.setAttribute('type', 'submit');
        });
      }

      Strophe.info('step 5 ----------');
      Strophe.forEachChild(x, 'field', function (field: Element) {
        var fieldVar = field.getAttribute('var');
        var valueDom = field.getElementsByTagName('value')[0];
        Strophe.info(fieldVar);
        switch (fieldVar) {
          case 'muc#roomconfig_maxusers':
            _setText(valueDom, options.optionsMaxUsers || 200);
            break;
          case 'muc#roomconfig_roomname':
            _setText(valueDom, options.subject || '');
            break;
          case 'muc#roomconfig_roomdesc':
            _setText(valueDom, options.description || '');
            break;
          case 'muc#roomconfig_publicroom': // public 1
            _setText(valueDom, +options.optionsPublic);
            break;
          case 'muc#roomconfig_membersonly':
            _setText(valueDom, +options.optionsMembersOnly);
            break;
          case 'muc#roomconfig_moderatedroom':
            _setText(valueDom, +options.optionsModerate);
            break;
          case 'muc#roomconfig_persistentroom':
            _setText(valueDom, 1);
            break;
          case 'muc#roomconfig_allowinvites':
            _setText(valueDom, +options.optionsAllowInvites);
            break;
          case 'muc#roomconfig_allowvisitornickchange':
            _setText(valueDom, 0);
            break;
          case 'muc#roomconfig_allowvisitorstatus':
            _setText(valueDom, 0);
            break;
          case 'allow_private_messages':
            _setText(valueDom, 0);
            break;
          case 'allow_private_messages_from_visitors':
            _setText(valueDom, 'nobody');
            break;
          default:
            break;
        }
      });

      // @ts-ignore
      var iq = $iq({ to: toRoom, type: 'set' }).c('query', { xmlns: 'http://jabber.org/protocol/muc#owner' }).cnode(x);
      me.context.stropheConn.sendIQ(
        iq.tree(),
        function (msgInfo: any) {
          me.addGroupMembers({
            list: options.members,
            roomId: roomId,
          });

          suc(options);
        },
        function (errInfo: any) {
          // errFn(errInfo);
        }
      );
      // sucFn(msgInfo);
    },
    function (errInfo: any) {
      // errFn(errInfo);
    }
  );
};

/**
 * createGroup create group
 *
 * 1. create group request -> obtain group admin
 * 2. obtain group admin info -> obtain group form
 * 3. complete group form -> group created successfully
 * 4. add user to group
 * 5. notify group member
 * @param options
 */
connection.prototype.createGroup = function (options: any) {
  this.groupOption = options;
  // var roomId = +new Date();
  var toRoom = this._getGroupJid(options.roomJid);
  var to = toRoom + '/' + this.context.userId;
  var suc = options.success || _utils.emptyfn;
  // @ts-ignore
  var pres = $pres({ to: to }).c('x', { xmlns: 'http://jabber.org/protocol/muc' }).up().c('create', { xmlns: 'http://jabber.org/protocol/muc' }).up();

  // createGroupACK
  this.sendCommand(pres.tree(), suc);
};

// user change status
connection.prototype.changeUserStatus = function (options: any) {
  if (!this.isOpened()) {
    console.log('ERROR: NOT CONNECTION TO changeUserStatus');
    return;
  }
  var userId = this.context.jid;
  var jid = options.roomJid + '/' + this.context.userId;
  var success = options.success || _utils.emptyfn;
  var err = options.error || _utils.emptyfn;
  // @ts-ignore
  var pres = $pres({ from: userId, to: jid });

  pres.c('show').t(options.type);
  pres.up().c('status').t(options.status);

  this.sendCommand(pres.tree(), success, err);
};

// Create a group via Rest interface
connection.prototype.createGroupNew = function (opt: any) {
  opt.data.owner = this.user;
  const self = this;
  const options = {
    url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/chatgroups',
    dataType: 'json',
    type: 'POST',
    data: JSON.stringify(opt.data),
    headers: {
      Authorization: 'Bearer ' + this.token,
      'Content-Type': 'application/json',
    },
    success: function (respData: any) {
      opt.success(respData);
      self.onCreateGroup(respData);
    }.bind(this),
    error: opt.error || _utils.emptyfn,
  };
  WebIM.utils.ajax(options);
};

// Block the group via Rest
connection.prototype.blockGroup = function (opt: any) {
  const groupId = 'notification_ignore_' + opt.groupId;
  const data: {
    entities: any[];
  } = {
    entities: [],
  };
  data.entities[0] = {};
  data.entities[0][groupId] = true;
  const options = {
    type: 'PUT',
    url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/' + 'users' + '/' + this.user,
    data: JSON.stringify(data),
    headers: {
      Authorization: 'Bearer ' + this.token,
      'Content-Type': 'application/json',
    },
    success: opt.success || _utils.emptyfn,
    error: opt.error || _utils.emptyfn,
  };
  WebIM.utils.ajax(options);
};

// Issue a membership application via Rest
connection.prototype.joinGroup = function (opt: any) {
  var options = {
    url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/' + 'chatgroups' + '/' + opt.groupId + '/' + 'apply',
    type: 'POST',
    dataType: 'json',
    headers: {
      Authorization: 'Bearer ' + this.token,
      'Content-Type': 'application/json',
    },
    success: opt.success || _utils.emptyfn,
    error: opt.error || _utils.emptyfn,
  };
  WebIM.utils.ajax(options);
};

// Get the list of groups through Rest
connection.prototype.listGroups = function (opt: any) {
  const requestData = {
    limit: opt.limit,
    cursor: opt.cursor,
  };
  if (!requestData['cursor']) delete requestData['cursor'];
  const options = {
    url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/publicchatgroups',
    type: 'GET',
    dataType: 'json',
    data: requestData,
    headers: {
      Authorization: 'Bearer ' + this.token,
      'Content-Type': 'application/json',
    },
    success: opt.success || _utils.emptyfn,
    error: opt.error || _utils.emptyfn,
  };
  WebIM.utils.ajax(options);
};

// Get group details based on groupid through Rest
connection.prototype.getGroupInfo = function (opt: any) {
  const options = {
    url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/chatgroups/' + opt.groupId,
    type: 'GET',
    dataType: 'json',
    headers: {
      Authorization: 'Bearer ' + this.token,
      'Content-Type': 'application/json',
    },
    success: opt.success || _utils.emptyfn,
    error: opt.error || _utils.emptyfn,
  };
  WebIM.utils.ajax(options);
};

//List all the groups that a user has joined through Rest
connection.prototype.getGroup = function (opt: any) {
  const options = {
    url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/' + 'users' + '/' + this.user + '/' + 'joined_chatgroups',
    dataType: 'json',
    type: 'GET',
    headers: {
      Authorization: 'Bearer ' + this.token,
      'Content-Type': 'application/json',
    },
    success: opt.success || _utils.emptyfn,
    error: opt.error || _utils.emptyfn,
  };
  WebIM.utils.ajax(options);
};

// List all members of the group via Rest
connection.prototype.listGroupMember = function (opt: any) {
  const requestData = {
      pagenum: opt.pageNum,
      pagesize: opt.pageSize,
    },
    groupId = opt.groupId;
  const options = {
    url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/chatgroups' + '/' + groupId + '/users',
    dataType: 'json',
    type: 'GET',
    data: requestData,
    headers: {
      Authorization: 'Bearer ' + this.token,
      'Content-Type': 'application/json',
    },
    success: opt.success || _utils.emptyfn,
    error: opt.error || _utils.emptyfn,
  };
  WebIM.utils.ajax(options);
};

// Remove the ban on user bans through Rest
connection.prototype.mute = function (opt: any) {
  const groupId = opt.groupId,
    requestData = {
      usernames: [opt.username],
      mute_duration: opt.muteDuration,
    },
    options = {
      url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/' + 'chatgroups' + '/' + groupId + '/' + 'mute',
      dataType: 'json',
      type: 'POST',
      headers: {
        Authorization: 'Bearer ' + this.token,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(requestData),
      success: opt.success || _utils.emptyfn,
      error: opt.error || _utils.emptyfn,
    };
  WebIM.utils.ajax(options);
};

// 通过Rest取消对用户禁言的禁止
connection.prototype.removeMute = function (opt: any) {
  const groupId = opt.groupId,
    username = opt.username;
  const options = {
    url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/' + 'chatgroups' + '/' + groupId + '/' + 'mute' + '/' + username,
    dataType: 'json',
    type: 'DELETE',
    headers: {
      Authorization: 'Bearer ' + this.token,
      'Content-Type': 'application/json',
    },
    success: opt.success || _utils.emptyfn,
    error: opt.error || _utils.emptyfn,
  };
  WebIM.utils.ajax(options);
};

// Get all group admins through Rest
connection.prototype.getGroupAdmin = function (opt: any) {
  var groupId = opt.groupId;
  var options = {
    url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/chatgroups' + '/' + groupId + '/admin',
    dataType: 'json',
    type: 'GET',
    headers: {
      Authorization: 'Bearer ' + this.token,
      'Content-Type': 'application/json',
    },
    success: opt.success || _utils.emptyfn,
    error: opt.error || _utils.emptyfn,
  };
  WebIM.utils.ajax(options);
};

// Get all banned members of a group through Rest
connection.prototype.getMuted = function (opt: any) {
  var groupId = opt.groupId;
  var options = {
    url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/chatgroups' + '/' + groupId + '/mute',
    dataType: 'json',
    type: 'GET',
    headers: {
      Authorization: 'Bearer ' + this.token,
      'Content-Type': 'application/json',
    },
    success: opt.success || _utils.emptyfn,
    error: opt.error || _utils.emptyfn,
  };
  WebIM.utils.ajax(options);
};

// Set the group administrator through Rest
connection.prototype.setAdmin = function (opt: any) {
  var groupId = opt.groupId,
    requestData = {
      newadmin: opt.username,
    },
    options = {
      url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/' + 'chatgroups' + '/' + groupId + '/' + 'admin',
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(requestData),
      headers: {
        Authorization: 'Bearer ' + this.token,
        'Content-Type': 'application/json',
      },
      success: opt.success || _utils.emptyfn,
      error: opt.error || _utils.emptyfn,
    };
  WebIM.utils.ajax(options);
};

// Cancel the group administrator via Rest
connection.prototype.removeAdmin = function (opt: any) {
  var groupId = opt.groupId,
    username = opt.username,
    options = {
      url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/' + 'chatgroups' + '/' + groupId + '/' + 'admin' + '/' + username,
      type: 'DELETE',
      dataType: 'json',
      headers: {
        Authorization: 'Bearer ' + this.token,
        'Content-Type': 'application/json',
      },
      success: opt.success || _utils.emptyfn,
      error: opt.error || _utils.emptyfn,
    };
  WebIM.utils.ajax(options);
};

// Allow users to join the group through Rest
connection.prototype.agreeJoinGroup = function (opt: any) {
  console.log('Agree Join Group New');
  var groupId = opt.groupId,
    requestData = {
      applicant: opt.applicant,
      verifyResult: true,
      reason: 'no clue',
    },
    options = {
      url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/' + 'chatgroups' + '/' + groupId + '/' + 'apply_verify',
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(requestData),
      headers: {
        Authorization: 'Bearer ' + this.token,
        'Content-Type': 'application/json',
      },
      success: opt.success || _utils.emptyfn,
      error: opt.error || _utils.emptyfn,
    };
  WebIM.utils.ajax(options);
};

// Reject the user to join the group through Rest
connection.prototype.rejectJoinGroup = function (opt: any) {
  var groupId = opt.groupId,
    requestData = {
      applicant: opt.applicant,
      verifyResult: false,
      reason: 'no clue',
    },
    options = {
      url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/' + 'chatgroups' + '/' + groupId + '/' + 'apply_verify',
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(requestData),
      headers: {
        Authorization: 'Bearer ' + this.token,
        'Content-Type': 'application/json',
      },
      success: opt.success || _utils.emptyfn,
      error: opt.error || _utils.emptyfn,
    };
  WebIM.utils.ajax(options);
};

// Add users to the group blacklist via Rest (single)
connection.prototype.groupBlockSingle = function (opt: any) {
  var groupId = opt.groupId,
    username = opt.username,
    options = {
      url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/' + 'chatgroups' + '/' + groupId + '/' + 'blocks' + '/' + 'users' + '/' + username,
      type: 'POST',
      dataType: 'json',
      headers: {
        Authorization: 'Bearer ' + this.token,
        'Content-Type': 'application/json',
      },
      success: opt.success || _utils.emptyfn,
      error: opt.error || _utils.emptyfn,
    };
  WebIM.utils.ajax(options);
};

// Add users to the group blacklist via Rest (batch)
connection.prototype.groupBlockMulti = function (opt: any) {
  var groupId = opt.groupId,
    usernames = opt.usernames,
    requestData = {
      usernames: usernames,
    },
    options = {
      url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/' + 'chatgroups' + '/' + groupId + '/' + 'blocks' + '/' + 'users',
      data: JSON.stringify(requestData),
      type: 'POST',
      dataType: 'json',
      headers: {
        Authorization: 'Bearer ' + this.token,
        'Content-Type': 'application/json',
      },
      success: opt.success || _utils.emptyfn,
      error: opt.error || _utils.emptyfn,
    };
  WebIM.utils.ajax(options);
};

// Remove users from the group blacklist via Rest (single)
connection.prototype.removeGroupBlockSingle = function (opt: any) {
  var groupId = opt.groupId,
    username = opt.username,
    options = {
      url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/' + 'chatgroups' + '/' + groupId + '/' + 'blocks' + '/' + 'users' + '/' + username,
      type: 'DELETE',
      dataType: 'json',
      headers: {
        Authorization: 'Bearer ' + this.token,
        'Content-Type': 'application/json',
      },
      success: opt.success || _utils.emptyfn,
      error: opt.error || _utils.emptyfn,
    };
  WebIM.utils.ajax(options);
};

// Remove users from the group blacklist via Rest (batch)
connection.prototype.removeGroupBlockMulti = function (opt: any) {
  var groupId = opt.groupId,
    username = opt.username.join(','),
    options = {
      url: this.apiUrl + '/' + this.orgName + '/' + this.appName + '/' + 'chatgroups' + '/' + groupId + '/' + 'blocks' + '/' + 'users' + '/' + username,
      type: 'DELETE',
      dataType: 'json',
      headers: {
        Authorization: 'Bearer ' + this.token,
        'Content-Type': 'application/json',
      },
      success: opt.success || _utils.emptyfn,
      error: opt.error || _utils.emptyfn,
    };
  WebIM.utils.ajax(options);
};

function _setText(valueDom: any, v: any) {
  if ('textContent' in valueDom) {
    valueDom.textContent = v;
  } else if ('text' in valueDom) {
    valueDom.text = v;
  } else {
    // Strophe.info('_setText 4 ----------');
    // valueDom.innerHTML = v;
  }
}

// @ts-ignore
let WebIM = window.WebIM || {};
WebIM.connection = connection;
WebIM.utils = _utils;
WebIM.statusCode = _code;
WebIM.message = message;
WebIM.logDebug = logDebug;
WebIM.doQuery = function (str: any, suc: any, fail: any) {
  // @ts-ignore
  if (typeof window.cefQuery === 'undefined') {
    return;
  }
  // @ts-ignore
  window.cefQuery({
    request: str,
    persistent: false,
    onSuccess: suc,
    onFailure: fail,
  });
};
// WebIM.conn = {
//   getBlacklist: () => {},
//   addToBlackList: params => {},
//   removeFromBlackList: params => {},
//   isClosed: () => Boolean,
//   isClosing: () => Boolean,
//   isOpened: () => Boolean,
//   joinChatRoom: options => {},
//   close: text => {},
//   resetReconnectNumTotal: () => {},
//   open: params => {},
//   getUniqueId: () => String,
//   send: options => {},
// };
// TODO: should remove below object
// WebIM.config = {
//   isMultiLoginSessions: false,
//   apiURL: '',
//   appkey: '',
//   read: Boolean,
//   chatState: Boolean,
//   update: Boolean,
//   delete: Boolean,
//   rhpToken: '',
//   fileURL: '',
// };

/**************************** debug ****************************/
function logMessage(message: any) {
  WebIM && WebIM.config.isDebug && console.log(WebIM.utils.ts() + '[recv] ', message.data);
}

function logDebug(header: any, message: any) {
  WebIM && WebIM.config.isDebug && console.log(header, WebIM.utils.ts() + ':', message);
}

if (WebIM && WebIM.config && WebIM.config.isDebug) {
  Strophe.Connection.prototype.rawOutput = function (data: any) {
    console.log('%c ' + WebIM.utils.ts() + '[send] ' + data, 'background-color: #e2f7da');
  };
}

if (WebIM && WebIM.config && WebIM.config.isSandBox) {
  WebIM.config.xmppURL = WebIM.config.xmppURL.replace('.easemob.', '-sandbox.easemob.');
  WebIM.config.apiURL = WebIM.config.apiURL.replace('.easemob.', '-sdb.easemob.');
}

export { WebIM };

// @ts-ignore
if (module.hot) {
  // @ts-ignore
  module.hot.accept?.();
}
